// DarkCryptoPro.js - יישום מתקדם לגרפי נרות יפניים עם חיבור מלא ל-Firebase
import React, { useState, useEffect, useRef } from 'react';
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { collection, getDocs, addDoc, query, orderBy, limit, where, doc, getDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase'; // ייבוא מודול Firebase קיים
import {} from './makorapoku.css'

// ייבוא אייקונים וקומפוננטות מעוצבות
import {
  Chart, Candlestick, Settings, Save, Search, ZoomIn, ZoomOut, 
  TrendingUp, TrendingDown, ArrowUp, ArrowDown, PlusCircle, MinusCircle,
  PlayCircle, PauseCircle, TrashCan, User, LogOut, Grid, Layers, 
  TargetPoint, AlertCircle, CheckCircle, XCircle, InfoCircle, 
  ChevronDown, ChevronRight, Sparkles, RefreshCircle, DownloadCloud,
  Upload, Image, Lock, Calendar, Clock, DollarSign, Award
} from './icons'; // נניח שיש לך קובץ אייקונים

// קומפוננטת העטיפה הראשית
const DarkCryptoPro = () => {
  // ========================= מצב (State) האפליקציה =========================
  const [data, setData] = useState([]);
  const [supportResistanceLines, setSupportResistanceLines] = useState([]);
  const [selectedCandleIndex, setSelectedCandleIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isSavedChartsOpen, setIsSavedChartsOpen] = useState(false);
  const [imageUploadOpen, setImageUploadOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [intervalRef, setIntervalRef] = useState(null);
  const [simulationSpeed, setSimulationSpeed] = useState(3);
  const [simulationInterval, setSimulationInterval] = useState(1000);
  const [trendBias, setTrendBias] = useState(50);
  const [volatilityLevel, setVolatilityLevel] = useState(3);
  const [marketStyle, setMarketStyle] = useState('bitcoin');
  const [currentMarketPhase, setCurrentMarketPhase] = useState('normal');
  const [phaseCounter, setPhaseCounter] = useState(0);
  const [phaseLength, setPhaseLength] = useState(10);
  const [lastCandleDirection, setLastCandleDirection] = useState(null);
  const [consecutiveSameDirection, setConsecutiveSameDirection] = useState(0);
  const [supportLevels, setSupportLevels] = useState([]);
  const [resistanceLevels, setResistanceLevels] = useState([]);
  const [toasts, setToasts] = useState([]);
  const [candleWidth, setCandleWidth] = useState(18);
  const [candleGap, setCandleGap] = useState(4);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [panOffset, setPanOffset] = useState(0);
  const [showGridLines, setShowGridLines] = useState(true);
  const [showPriceLabels, setShowPriceLabels] = useState(true);
  const [showSupportResistance, setShowSupportResistance] = useState(true);
  const [referencePrice, setReferencePrice] = useState(null);
  const [showReferenceLine, setShowReferenceLine] = useState(false);
  const [savedCharts, setSavedCharts] = useState([]);
  const [user, setUser] = useState(null);
  const [importantPoints, setImportantPoints] = useState([]);
  const [isMarkingImportantPoint, setIsMarkingImportantPoint] = useState(false);
  const [importantPointColor, setImportantPointColor] = useState('red');
  const [candleBoxes, setCandleBoxes] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);
  const [dragStartPanOffset, setDragStartPanOffset] = useState(0);
  const [priceInfo, setPriceInfo] = useState({ visible: false, x: 0, y: 0, candle: null });
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, candleIndex: null });
  const [imagePreview, setImagePreview] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('candles'); // לשונית פעילה בסרגל הצד
  const [confirmAction, setConfirmAction] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareLink, setShareLink] = useState('');
  const [isUserSettingsOpen, setIsUserSettingsOpen] = useState(false);
  const [userSettings, setUserSettings] = useState({
    darkMode: true,
    defaultTimeframe: '1D',
    defaultMarketStyle: 'bitcoin',
    notifications: true,
    autoSave: true
  });
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [selectedTimeframe, setSelectedTimeframe] = useState('1D');
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [chartTags, setChartTags] = useState([]);
  const [chartTitle, setChartTitle] = useState('גרף ללא כותרת');
  const [chartDescription, setChartDescription] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const [chartLevel, setChartLevel] = useState(1);
  const [activeTool, setActiveTool] = useState(null);

  // רפרנסים
  const canvasRef = useRef(null);
  const chartMargin = 80;

  // ========================= אפקטים (Effects) ואתחול =========================
  const formatNumber = (num) => {
    return num.toLocaleString('he-IL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  const getPercentageChange = () => {
    if (data.length < 2) return { value: '0.00', isUp: true };
    
    const last = data[data.length - 1];
    const prevClose = data[data.length - 2].close;
    const change = ((last.close - prevClose) / prevClose) * 100;
    
    return {
      value: Math.abs(change).toFixed(2),
      isUp: change >= 0
    };
  };
  
  // Firebase אימות משתמש
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        // טעינת הגדרות המשתמש מ-Firebase
        loadUserSettings(user.uid);
        // טעינת התראות
        loadUserNotifications(user.uid);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // טעינת הגדרות משתמש מ-Firebase
  const loadUserSettings = async (userId) => {
    try {
      const settingsRef = collection(db, "userSettings");
      const q = query(settingsRef, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const settingsData = querySnapshot.docs[0].data();
        setUserSettings(prev => ({
          ...prev,
          ...settingsData.settings
        }));
      }
    } catch (error) {
      console.error("Error loading user settings:", error);
      showToast('שגיאה בטעינת הגדרות', error.message, 'error');
    }
  };

  // טעינת התראות משתמש מ-Firebase
  const loadUserNotifications = async (userId) => {
    try {
      const notificationsRef = collection(db, "notifications");
      const q = query(
        notificationsRef, 
        where("userId", "==", userId),
        where("read", "==", false),
        orderBy("createdAt", "desc"),
        limit(10)
      );
      const querySnapshot = await getDocs(q);
      
      const notificationsList = [];
      querySnapshot.forEach((doc) => {
        notificationsList.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setNotifications(notificationsList);
      setNotificationCount(notificationsList.length);
    } catch (error) {
      console.error("Error loading notifications:", error);
    }
  };

  // טעינת גרפים שמורים מ-Firebase
  useEffect(() => {
    if (user) {
      fetchSavedCharts();
    }
  }, [user]);

  // ציור הגרף כשהנתונים משתנים
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    
    // הגדרת קנבס לתצוגות DPI גבוהות
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    ctx.scale(dpr, dpr);
    canvas.style.width = `${rect.width}px`;
    canvas.style.height = `${rect.height}px`;
    
    drawChart(ctx, canvas.width, canvas.height);
  }, [
    data, supportResistanceLines, supportLevels, resistanceLevels, importantPoints,
    candleWidth, candleGap, zoomLevel, panOffset, showGridLines, showPriceLabels,
    showSupportResistance, referencePrice, showReferenceLine
  ]);

  // טיפול בשינוי גודל חלון
  useEffect(() => {
    const handleResize = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      const ctx = canvas.getContext('2d');
      
      // איפוס מימדי הקנבס
      const dpr = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
      ctx.scale(dpr, dpr);
      canvas.style.width = `${rect.width}px`;
      canvas.style.height = `${rect.height}px`;
      
      drawChart(ctx, canvas.width, canvas.height);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ניקוי אינטרוול בעת פירוק הקומפוננטה
  useEffect(() => {
    return () => {
      if (intervalRef) {
        clearInterval(intervalRef);
      }
    };
  }, [intervalRef]);

  // ========================= פונקציות Firebase =========================

  // שליפת גרפים שמורים מ-Firebase
  const fetchSavedCharts = async () => {
    if (!user) return;
    
    try {
      setIsLoadingData(true);
      const chartsRef = collection(db, "savedCharts");
      const q = query(
        chartsRef, 
        where("userId", "==", user.uid), 
        orderBy("savedAt", "desc"), 
        limit(20)
      );
      const querySnapshot = await getDocs(q);
      
      const charts = [];
      querySnapshot.forEach((doc) => {
        charts.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setSavedCharts(charts);
      setIsLoadingData(false);
    } catch (error) {
      console.error("Error fetching saved charts:", error);
      showToast('שגיאה בטעינת גרפים', error.message, 'error');
      setIsLoadingData(false);
    }
  };

  // שמירת גרף ל-Firebase
  const saveChartToFirebase = async () => {
    if (!user) {
      showToast('שגיאה', 'עליך להתחבר כדי לשמור גרפים', 'error');
      return;
    }

    if (data.length === 0) {
      showToast('שגיאה', 'אין נתונים לשמירה', 'error');
      return;
    }

    try {
      setIsLoadingData(true);
      // עיצוב הנתונים בהתאם למבנה
      const formattedData = data.map(candle => ({
        time: candle.time,
        open: candle.open,
        high: candle.high,
        low: candle.low,
        close: candle.close,
        volume: candle.volume || Math.floor(Math.random() * 1000) + 100 // הוספת נפח אקראי אם אין
      }));

      const chartData = {
        title: chartTitle,
        description: chartDescription,
        level: chartLevel,
        isPublic: isPublic,
        tags: chartTags,
        candlestickData: formattedData,
        importantPoints,
        userId: user.uid,
        username: user.displayName || user.email,
        savedAt: new Date(),
        chartSettings: {
          candleWidth,
          gap: candleGap,
          zoomLevel,
          showGridLines,
          showPriceLabels,
          showSupportResistance
        },
        marketSettings: {
          trendBias,
          volatilityLevel,
          marketStyle,
          selectedTimeframe
        },
        supportResistance: {
          supportLevels,
          resistanceLevels,
          manualLines: supportResistanceLines
        }
      };

      const docRef = await addDoc(collection(db, "savedCharts"), chartData);
      
      // יצירת לינק שיתוף אם הגרף מוגדר כציבורי
      if (isPublic) {
        const shareUrl = `${window.location.origin}/share/${docRef.id}`;
        setShareLink(shareUrl);
        setIsShareModalOpen(true);
      }
      
      showToast('שמירה הצליחה', 'הגרף נשמר בהצלחה', 'success');
      
      // רענון רשימת הגרפים השמורים
      fetchSavedCharts();
      setIsLoadingData(false);
    } catch (error) {
      console.error("Error saving chart:", error);
      showToast('שגיאת שמירה', error.message, 'error');
      setIsLoadingData(false);
    }
  };

  // טעינת גרף ספציפי מ-Firebase
  const loadChartFromFirebase = async (chartId) => {
    try {
      setIsLoadingData(true);
      const docRef = doc(db, "savedCharts", chartId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const chartData = docSnap.data();
        loadChart(chartData);
        
        // עדכון פרטי הגרף
        setChartTitle(chartData.title || 'גרף ללא כותרת');
        setChartDescription(chartData.description || '');
        setChartTags(chartData.tags || []);
        setIsPublic(chartData.isPublic || false);
        setChartLevel(chartData.level || 1);
        
        showToast('טעינה הצליחה', 'הגרף נטען בהצלחה', 'success');
      } else {
        showToast('שגיאה', 'הגרף לא נמצא', 'error');
      }
      setIsLoadingData(false);
    } catch (error) {
      console.error("Error loading chart:", error);
      showToast('שגיאת טעינה', error.message, 'error');
      setIsLoadingData(false);
    }
  };

  // מחיקת גרף מ-Firebase
  const deleteChartFromFirebase = async (chartId) => {
    if (!user) return;
    
    try {
      setIsLoadingData(true);
      await deleteDoc(doc(db, "savedCharts", chartId));
      
      // רענון רשימת הגרפים
      fetchSavedCharts();
      showToast('מחיקה הצליחה', 'הגרף נמחק בהצלחה', 'success');
      setIsLoadingData(false);
    } catch (error) {
      console.error("Error deleting chart:", error);
      showToast('שגיאת מחיקה', error.message, 'error');
      setIsLoadingData(false);
    }
  };

  // שמירת הגדרות משתמש ל-Firebase
  const saveUserSettings = async () => {
    if (!user) return;
    
    try {
      // בדיקה אם כבר קיימות הגדרות למשתמש
      const settingsRef = collection(db, "userSettings");
      const q = query(settingsRef, where("userId", "==", user.uid));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        // יצירת הגדרות חדשות
        await addDoc(settingsRef, {
          userId: user.uid,
          settings: userSettings,
          updatedAt: new Date()
        });
      } else {
        // עדכון הגדרות קיימות
        const docId = querySnapshot.docs[0].id;
        await updateDoc(doc(db, "userSettings", docId), {
          settings: userSettings,
          updatedAt: new Date()
        });
      }
      
      showToast('הגדרות', 'ההגדרות נשמרו בהצלחה', 'success');
    } catch (error) {
      console.error("Error saving user settings:", error);
      showToast('שגיאה בשמירת הגדרות', error.message, 'error');
    }
  };

  // עדכון סטטוס 'נקרא' להתראה ב-Firebase
  const markNotificationAsRead = async (notificationId) => {
    try {
      await updateDoc(doc(db, "notifications", notificationId), {
        read: true
      });
      
      // עדכון המצב המקומי
      setNotifications(prev => prev.filter(n => n.id !== notificationId));
      setNotificationCount(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  // ========================= פונקציות התראה וממשק משתמש =========================
  
  // הצגת התראה
  const showToast = (title, message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, title, message, type }]);
    
    // הסרה אוטומטית של התראה אחרי 3 שניות
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 3000);
  };

  // פונקציות התחברות והתנתקות
  const handleLogin = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Login failed:", error);
      showToast('שגיאת התחברות', error.message, 'error');
    }
  };

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout failed:", error);
      showToast('שגיאת התנתקות', error.message, 'error');
    }
  };

  // הצגת תיבת דו-שיח לאישור פעולה
  const showConfirmDialog = (message, action) => {
    setConfirmMessage(message);
    setConfirmAction(() => action);
    setIsConfirmModalOpen(true);
  };

  // הצגת/הסתרת הסרגל הצדדי
  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  // ========================= פונקציות ניהול נרות ושמירה =========================

  // טעינת גרף מנתונים שמורים
  const loadChart = (chartData) => {
    if (!chartData) return;
    
    // טעינת נתוני נרות
    setData(chartData.candlestickData || []);
    
    // טעינת נקודות חשובות
    setImportantPoints(chartData.importantPoints || []);
    
    // טעינת הגדרות גרף
    if (chartData.chartSettings) {
      const { candleWidth, gap, zoomLevel, showGridLines: grid, showPriceLabels: labels, showSupportResistance: sr } = chartData.chartSettings;
      if (candleWidth) setCandleWidth(candleWidth);
      if (gap) setCandleGap(gap);
      if (zoomLevel) setZoomLevel(zoomLevel);
      if (grid !== undefined) setShowGridLines(grid);
      if (labels !== undefined) setShowPriceLabels(labels);
      if (sr !== undefined) setShowSupportResistance(sr);
    }
    
    // טעינת הגדרות שוק
    if (chartData.marketSettings) {
      const { trendBias, volatilityLevel, marketStyle, selectedTimeframe: tf } = chartData.marketSettings;
      if (trendBias !== undefined) setTrendBias(trendBias);
      if (volatilityLevel !== undefined) setVolatilityLevel(volatilityLevel);
      if (marketStyle) setMarketStyle(marketStyle);
      if (tf) setSelectedTimeframe(tf);
    }
    
    // טעינת נתוני תמיכה/התנגדות
    if (chartData.supportResistance) {
      const { supportLevels, resistanceLevels, manualLines } = chartData.supportResistance;
      if (supportLevels) setSupportLevels(supportLevels);
      if (resistanceLevels) setResistanceLevels(resistanceLevels);
      if (manualLines) setSupportResistanceLines(manualLines);
    }
    
    // איפוס מיקום תצוגה
    setPanOffset(0);
    
    showToast('טעינה הצליחה', `נטענו ${chartData.candlestickData?.length || 0} נרות`, 'success');
    
    // סגירת תצוגת גרפים שמורים
    setIsSavedChartsOpen(false);
  };

  // הוספת נקודה חשובה
  const addImportantPoint = (time, price, color = importantPointColor) => {
    setImportantPoints(prev => [...prev, { time, price, color }]);
    setIsMarkingImportantPoint(false);
    showToast('נקודה חשובה נוספה', `נקודה נוספה במחיר ${price}`, 'success');
  };

  // הוספת נר
  const addCandle = (direction, size, wickless = false, forceProperties = null) => {
    let newData = [...data];
    
    if (forceProperties) {
      // אם סופקו מאפיינים ספציפיים, השתמש בהם
      newData.push(forceProperties);
    } else {
      // יצירת נר מציאותי בהתבסס על נתונים קודמים ופרמטרים של השוק
      const lastCandle = newData.length > 0 ? newData[newData.length - 1] : null;
      const newCandle = generateRealisticCandle(lastCandle, direction, size, wickless);
      newData.push(newCandle);
    }
    
    setData(newData);
    
    // זיהוי רמות תמיכה/התנגדות פוטנציאליות
    detectSupportResistanceLevels(newData);
  };

  // יצירת נר מציאותי
  const generateRealisticCandle = (lastCandle, direction, size, wickless = false) => {
    // אם אין נר קודם, יצירת נר ראשוני
    if (!lastCandle) {
      const basePrice = 28950; // מחיר התחלתי משודרג (ביטקוין עדכני)
      let open = basePrice;
      let close;
      
      // החלת כיוון וגודל
      const baseChange = size === 'small' ? 250 : 750;
      close = direction === 'up' ? open + baseChange : open - baseChange;
      
      // הוספת פתילים אם צריך
      const high = wickless ? Math.max(open, close) : Math.max(open, close) + (baseChange * 0.4);
      const low = wickless ? Math.min(open, close) : Math.min(open, close) - (baseChange * 0.4);
      
      const date = new Date();
      
      return {
        time: date.toISOString().split('T')[0],
        open: parseFloat(open.toFixed(2)),
        high: parseFloat(high.toFixed(2)),
        low: parseFloat(low.toFixed(2)),
        close: parseFloat(close.toFixed(2)),
        volume: Math.floor(Math.random() * 2000 + 500)  // נפח אקראי יותר ריאליסטי
      };
    }
    
    // שימוש במחיר האחרון כמחיר ייחוס
    const open = lastCandle.close;
    
    // חישוב תנודתיות בסיסית בהתבסס על רמת התנודתיות וסגנון השוק
    let baseVolatility;
    
    switch (marketStyle) {
      case 'bitcoin':
        baseVolatility = 0.8 + (volatilityLevel * 0.5);
        break;
      case 'stock':
        baseVolatility = 0.3 + (volatilityLevel * 0.2);
        break;
      case 'forex':
        baseVolatility = 0.1 + (volatilityLevel * 0.1);
        break;
      case 'random':
        baseVolatility = 0.5 + (volatilityLevel * 0.6);
        break;
      default:
        baseVolatility = 0.5 + (volatilityLevel * 0.3);
    }
    
    // החלת מקדם קנה מידה בהתבסס על המחיר הנוכחי
    const priceScale = Math.max(1, open / 1000);
    let volatility = baseVolatility * priceScale;
    
    // התאמת תנודתיות בהתבסס על שלב השוק
    switch (currentMarketPhase) {
      case 'trending':
        volatility *= 1.2;
        break;
      case 'volatile':
        volatility *= 2.2;  // תנודתיות גבוהה יותר
        break;
      case 'reversing':
        volatility *= 1.7;  // תנודתיות גבוהה יותר בהיפוך
        break;
    }
    
    // קביעת הסתברות לכיוון בהתבסס על הטיה וביצועי שוק
    let upProbability = trendBias / 100; // המרת 0-100 ל-0-1
    
    // התאמת הסתברות כיוון בהתבסס על שלב השוק ונרות רצופים
    if (currentMarketPhase === 'trending') {
      // בשלב המגמה, אנחנו מדגישים את המגמה העיקרית
      upProbability = upProbability > 0.5 ? 
                     Math.min(upProbability + 0.2, 0.9) : 
                     Math.max(upProbability - 0.2, 0.1);
    } else if (currentMarketPhase === 'reversing') {
      // בשלב ההיפוך, אנחנו הולכים נגד הכיוון האחרון
      if (lastCandleDirection === 'up') {
        upProbability = Math.max(upProbability - 0.3, 0.2);
      } else {
        upProbability = Math.min(upProbability + 0.3, 0.8);
      }
    }
    
    // אם היו לנו כמה נרות באותו כיוון, הגדלת הסיכוי להיפוך
    if (consecutiveSameDirection > 3) {
      const reversal = 0.1 * Math.min(consecutiveSameDirection - 3, 3);
      upProbability = lastCandleDirection === 'up' ? 
                     Math.max(upProbability - reversal, 0.1) : 
                     Math.min(upProbability + reversal, 0.9);
    }
    
    // דריסת כיוון אם צוין במפורש
    let actualDirection;
    if (direction === 'up' || direction === 'down') {
      actualDirection = direction;
    } else {
      // אחרת השתמש בהסתברות
      actualDirection = Math.random() < upProbability ? 'up' : 'down';
    }
    
    // חישוב שינוי בהתבסס על תנודתיות וגודל
    let change;
    if (size === 'small') {
      change = (Math.random() * volatility * 0.5) + (volatility * 2.1);
    } else if (size === 'large') {
      change = (Math.random() * volatility) + (volatility * 7.3);
    } else {
      // גודל רגיל
      change = (Math.random() * volatility * 0.7) + (volatility * 0.2);
    }
    
    // החלת כיוון על מחיר סגירה
    let close = actualDirection === 'up' ? open + change : open - change;
    
    // הוספת פתילים
    let wickScale = 0.3;
    if (wickless) {
      wickScale = 0;
    } else if (currentMarketPhase === 'volatile') {
      wickScale = 0.7; // פתילים ארוכים יותר בשלבים תנודתיים
    }
    
    // פתילים עם אקראיות יותר ריאליסטית
    const wickUpSize = Math.random() * change * wickScale * (1 + Math.random() * 0.5);
    const wickDownSize = Math.random() * change * wickScale * (1 + Math.random() * 0.5);
    
    const high = Math.max(open, close) + wickUpSize;
    const low = Math.min(open, close) - wickDownSize;
    
    // יצירת תאריך לנר
    const date = new Date();
    if (data.length > 0) {
      const lastDate = new Date(lastCandle.time);
      // מבוסס על מסגרת הזמן הנבחרת
      switch (selectedTimeframe) {
        case '15M':
          date.setMinutes(lastDate.getMinutes() + 15);
          break;
        case '1H':
          date.setHours(lastDate.getHours() + 1);
          break;
        case '4H':
          date.setHours(lastDate.getHours() + 4);
          break;
        case '1W':
          date.setDate(lastDate.getDate() + 7);
          break;
        case '1D':
        default:
          date.setDate(lastDate.getDate() + 1);
      }
    }
    
    // חישוב נפח מציאותי שמשתנה בהתאם לגודל ולשלב השוק
    let volume;
    const baseVolume = lastCandle.volume || 500;
    
    if (actualDirection === 'up' && size === 'large') {
      // נפח גבוה יותר בנרות גדולים עולים (התלהבות קונים)
      volume = baseVolume * (1 + Math.random() * 1.5);
    } else if (actualDirection === 'down' && size === 'large') {
      // נפח גבוה גם בנרות גדולים יורדים (פניקה)
      volume = baseVolume * (1 + Math.random() * 1.3);
    } else if (currentMarketPhase === 'volatile') {
      // נפח גבוה בשלבים תנודתיים
      volume = baseVolume * (1 + Math.random() * 1);
    } else if (currentMarketPhase === 'trending') {
      // נפח עולה בהדרגה במהלך מגמה
      volume = baseVolume * (1 + Math.random() * 0.3);
    } else {
      // במצבים אחרים, שינוי מתון בנפח
      volume = baseVolume * (0.7 + Math.random() * 0.6);
    }
    
    // עדכון מעקבי מצב שוק
    setLastCandleDirection(actualDirection);
    if (data.length > 0 && data[data.length - 1].close > data[data.length - 1].open === (actualDirection === 'up')) {
      setConsecutiveSameDirection(prev => prev + 1);
    } else {
      setConsecutiveSameDirection(1);
    }
    
    // עדכון שלב שוק
    setPhaseCounter(prev => {
      const newCounter = prev + 1;
      if (newCounter >= phaseLength) {
        updateMarketPhase();
        return 0;
      }
      return newCounter;
    });
    
    return {
      time: date.toISOString().split('T')[0],
      open: parseFloat(open.toFixed(2)),
      high: parseFloat(high.toFixed(2)),
      low: parseFloat(low.toFixed(2)),
      close: parseFloat(close.toFixed(2)),
      volume: Math.floor(volume)
    };
  };

  // עדכון שלב שוק
  const updateMarketPhase = () => {
    const phases = ['normal', 'trending', 'volatile', 'reversing'];
    const weights = {
      'normal': { 'normal': 0.5, 'trending': 0.3, 'volatile': 0.1, 'reversing': 0.1 },
      'trending': { 'normal': 0.2, 'trending': 0.6, 'volatile': 0.1, 'reversing': 0.1 },
      'volatile': { 'normal': 0.3, 'trending': 0.1, 'volatile': 0.4, 'reversing': 0.2 },
      'reversing': { 'normal': 0.3, 'trending': 0.1, 'volatile': 0.2, 'reversing': 0.4 }
    };
    
    // בחירת השלב הבא בהתבסס על משקלי השלב הנוכחי
    const currentWeights = weights[currentMarketPhase];
    let random = Math.random();
    let cumulativeWeight = 0;
    
    for (const phase in currentWeights) {
      cumulativeWeight += currentWeights[phase];
      if (random <= cumulativeWeight) {
        setCurrentMarketPhase(phase);
        break;
      }
    }
    
    // קביעת אורך שלב זה (5-15 נרות)
    setPhaseLength(5 + Math.floor(Math.random() * 10));
    setPhaseCounter(0);
    
    console.log(`Market phase changed to: ${currentMarketPhase} for ${phaseLength} candles`);
  };

  // זיהוי רמות תמיכה/התנגדות אפשריות
  const detectSupportResistanceLevels = (chartData = data) => {
    if (chartData.length < 5) return;
    
    const lastCandle = chartData[chartData.length - 1];
    const recentSwingHigh = findRecentSwingHigh(chartData, 5);
    const recentSwingLow = findRecentSwingLow(chartData, 5);
    
    // בדיקה עבור שיא גבוה (התנגדות פוטנציאלית)
    if (recentSwingHigh && !resistanceLevels.some(level => Math.abs(level.price - recentSwingHigh.high) / recentSwingHigh.high < 0.01)) {
      setResistanceLevels(prev => [
        ...prev,
        {
          price: recentSwingHigh.high,
          strength: 1,
          candle: chartData.indexOf(recentSwingHigh)
        }
      ]);
    }
    
    // בדיקה עבור שפל נמוך (תמיכה פוטנציאלית)
    if (recentSwingLow && !supportLevels.some(level => Math.abs(level.price - recentSwingLow.low) / recentSwingLow.low < 0.01)) {
      setSupportLevels(prev => [
        ...prev,
        {
          price: recentSwingLow.low,
          strength: 1,
          candle: chartData.indexOf(recentSwingLow)
        }
      ]);
    }
    
    // עדכון חוזק רמות בהתבסס על ביצועי מחיר
    updateSupportResistanceLevels();
  };

  // מציאת שיא גבוה אחרון
  const findRecentSwingHigh = (chartData, lookback) => {
    if (chartData.length < lookback + 2) return null;
    
    for (let i = chartData.length - 2; i >= lookback; i--) {
      let isSwingHigh = true;
      const current = chartData[i];
      
      // בדיקה אם זה גבוה יותר מנרות סביבו
      for (let j = 1; j <= lookback/2; j++) {
        if (i-j >= 0 && chartData[i-j].high >= current.high) {
          isSwingHigh = false;
          break;
        }
        if (i+j < chartData.length && chartData[i+j].high >= current.high) {
          isSwingHigh = false;
          break;
        }
      }
      
      if (isSwingHigh) return current;
    }
    
    return null;
  };

  // מציאת שפל נמוך אחרון
  const findRecentSwingLow = (chartData, lookback) => {
    if (chartData.length < lookback + 2) return null;
    
    for (let i = chartData.length - 2; i >= lookback; i--) {
      let isSwingLow = true;
      const current = chartData[i];
      
      // בדיקה אם זה נמוך יותר מנרות סביבו
      for (let j = 1; j <= lookback/2; j++) {
        if (i-j >= 0 && chartData[i-j].low <= current.low) {
          isSwingLow = false;
          break;
        }
        if (i+j < chartData.length && chartData[i+j].low <= current.low) {
          isSwingLow = false;
          break;
        }
      }
      
      if (isSwingLow) return current;
    }
    
    return null;
  };

  // עדכון רמות תמיכה/התנגדות
  const updateSupportResistanceLevels = () => {
    if (data.length < 2) return;
    
    const lastCandle = data[data.length - 1];
    const prevCandle = data[data.length - 2];
    
    // עדכון רמות התנגדות
    const updatedResistanceLevels = resistanceLevels.map(level => {
      let newLevel = { ...level };
      
      // מחיר התקרב להתנגדות מלמטה
      if (lastCandle.high > level.price * 0.98 && lastCandle.high < level.price * 1.02) {
        newLevel.strength++;
      }
      
      // מחיר פרץ התנגדות
      if (prevCandle.close < level.price && lastCandle.close > level.price) {
        newLevel.strength--;
        // הפיכת התנגדות שנפרצה לתמיכה
        if (level.strength > 0) {
          setSupportLevels(prev => [
            ...prev,
            {
              price: level.price,
              strength: 1,
              candle: data.length - 1
            }
          ]);
        }
      }
      
      return newLevel;
    });
    
    // עדכון רמות תמיכה
    const updatedSupportLevels = supportLevels.map(level => {
      let newLevel = { ...level };
      
      // מחיר התקרב לתמיכה מלמעלה
      if (lastCandle.low < level.price * 1.02 && lastCandle.low > level.price * 0.98) {
        newLevel.strength++;
      }
      
      // מחיר פרץ תמיכה
      if (prevCandle.close > level.price && lastCandle.close < level.price) {
        newLevel.strength--;
        // הפיכת תמיכה שנפרצה להתנגדות
        if (newLevel.strength > 0) {
          setResistanceLevels(prev => [
            ...prev,
            {
              price: level.price,
              strength: 1,
              candle: data.length - 1
            }
          ]);
        }
      }
      
      return newLevel;
    });
    
    // הסרת רמות חלשות
    setResistanceLevels(updatedResistanceLevels.filter(level => level.strength > 0));
    setSupportLevels(updatedSupportLevels.filter(level => level.strength > 0));
  };

  // הסרת נר ספציפי
  const removeCandle = (index) => {
    if (index >= 0 && index < data.length) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  // הסרת נר/ות אחרון/ים
  const removeLastCandles = (num = 1) => {
    if (data.length === 0) return;
    setData(prev => prev.slice(0, -num));
  };

  // ניקוי כל הנרות
  const clearAllCandles = () => {
    showConfirmDialog(
      'האם אתה בטוח שברצונך למחוק את כל הנרות? פעולה זו לא ניתנת לביטול.', 
      () => {
        setData([]);
        setSupportResistanceLines([]);
        setSupportLevels([]);
        setResistanceLevels([]);
        setImportantPoints([]);
        
        showToast('הגרף נוקה', 'כל הנרות הוסרו', 'info');
      }
    );
  };

  // התחלת סימולציה
  const startSimulation = () => {
    setIsPlaying(true);
    
    // חישוב אינטרוול בהתבסס על מהירות סימולציה
    let interval;
    switch (simulationSpeed) {
      case 1: interval = 2000; break;
      case 2: interval = 1500; break;
      case 3: interval = 1000; break;
      case 4: interval = 500; break;
      case 5: interval = 250; break;
      default: interval = 1000;
    }
    
    setSimulationInterval(interval);
    
    // יצירת נרות במרווחי זמן
    const newIntervalRef = setInterval(() => {
      // יצירת נר חדש עם התנהגות מחיר מציאותית
      addCandle();
    }, interval);
    
    setIntervalRef(newIntervalRef);
  };

  // עצירת סימולציה
  const stopSimulation = () => {
    if (intervalRef) {
      clearInterval(intervalRef);
      setIntervalRef(null);
    }
    setIsPlaying(false);
  };

  // הפעלת/עצירת סימולציה
  const toggleSimulation = () => {
    if (isPlaying) {
      stopSimulation();
    } else {
      startSimulation();
    }
  };

  // הוספת קו תמיכה/התנגדות
  const addSupportResistanceLine = (price, type) => {
    setSupportResistanceLines(prev => [
      ...prev,
      { price, type }
    ]);
  };

  // טעינת נתוני דוגמה
  const loadSampleData = () => {
    // ניקוי נתונים קיימים
    setData([]);
    setSupportResistanceLines([]);
    setSupportLevels([]);
    setResistanceLevels([]);
    setImportantPoints([]);
    
    // נתוני דוגמה דמויי ביטקוין עם דפוסים מציאותיים
    let initialPrice = 29450; // מחיר התחלתי BTC יותר עדכני
    let currentPrice = initialPrice;
    let trendPhase = 'up'; // התחל עם מגמה עולה
    let phaseLength = 10;
    let phaseCounter = 0;
    let volatility = 450; // תנודתיות גבוהה יותר לדוגמה מעניינת
    let newData = [];
    
    // יצירת 60 נרות עם התנהגות שוק מציאותית
    for (let i = 0; i < 60; i++) {
      // עדכון שלב שוק במידת הצורך
      phaseCounter++;
      if (phaseCounter >= phaseLength) {
        // שינוי שלב שוק
        const phases = ['up', 'consolidation', 'down', 'consolidation'];
        const currentIndex = phases.indexOf(trendPhase);
        const nextIndex = (currentIndex + 1) % phases.length;
        trendPhase = phases[nextIndex];
        
        phaseLength = 8 + Math.floor(Math.random() * 15); // 8-22 נרות לכל שלב
        phaseCounter = 0;
        
        // התאמת תנודתיות בהתבסס על שלב
        if (trendPhase === 'consolidation') {
          volatility = initialPrice * 0.005; // תנודתיות נמוכה יותר בזמן התכנסות
        } else {
          volatility = initialPrice * 0.02; // תנודתיות גבוהה יותר בזמן מגמות
        }
      }
      
      // קביעת הסתברות כיוון נר בהתבסס על שלב
      let upProbability;
      switch (trendPhase) {
        case 'up':
          upProbability = 0.7; // 70% סיכוי לנרות עולים במגמה עולה
          break;
        case 'down':
          upProbability = 0.3; // 30% סיכוי לנרות עולים במגמה יורדת
          break;
        case 'consolidation':
          upProbability = 0.5; // 50% סיכוי בהתכנסות
          break;
        default:
          upProbability = 0.5;
      }
      
      // הוספת אקראיות כדי למנוע דפוסים צפויים מדי
      upProbability += (Math.random() * 0.2 - 0.1);
      
      // קביעה אם נר זה עולה או יורד
      const isUp = Math.random() < upProbability;
      
      // חישוב נתוני נר
      const open = currentPrice;
      
      // חישוב גודל שינוי בהתבסס על תנודתיות
      let change;
      if (trendPhase === 'consolidation') {
        // שינויים קטנים יותר בזמן התכנסות
        change = (Math.random() * volatility * 0.5);
      } else {
        // שינויים גדולים יותר בזמן מגמות
        change = (Math.random() * volatility);
        
        // לפעמים הוספת נר "זינוק" למציאותיות
        if (Math.random() < 0.15) {
          change *= 2;
        }
      }
      
      // החלת כיוון
      const close = isUp ? open + change : open - change;
      
      // חישוב פתילים
      let upperWick, lowerWick;
      
      if (trendPhase === 'consolidation') {
        // פתילים ארוכים יותר בהתכנסות
        upperWick = Math.random() * change * 1.2;
        lowerWick = Math.random() * change * 1.2;
      } else if (trendPhase === 'up' && isUp) {
        // במגמה עולה, נרות עולים לעתים קרובות עם פתילים עליונים ארוכים
        upperWick = Math.random() * change * 0.8;
        lowerWick = Math.random() * change * 0.4;
      } else if (trendPhase === 'down' && !isUp) {
        // במגמה יורדת, נרות יורדים לעתים קרובות עם פתילים תחתונים ארוכים
        upperWick = Math.random() * change * 0.4;
        lowerWick = Math.random() * change * 0.8;
      } else {
        // חלוקת פתיל רגילה
        upperWick = Math.random() * change * 0.6;
        lowerWick = Math.random() * change * 0.6;
      }
      
      const high = Math.max(open, close) + upperWick;
      const low = Math.min(open, close) - lowerWick;
      
      // חישוב נפח מציאותי
      let volume = 500 + Math.floor(Math.random() * 1500);
      
      // הגדלת נפח בנקודות מפתח
      if ((trendPhase === 'up' && isUp && Math.random() < 0.3) || 
          (trendPhase === 'down' && !isUp && Math.random() < 0.3)) {
        volume *= 2; // נפח גבוה בנקודות מפנה או המשך מגמה חזקה
      }
      
      // יצירת תאריך
      const date = new Date();
      date.setDate(date.getDate() - (60 - i));
      
      // הוספת נר לנתונים
      newData.push({
        time: date.toISOString().split('T')[0],
        open: parseFloat(open.toFixed(2)),
        high: parseFloat(high.toFixed(2)),
        low: parseFloat(low.toFixed(2)),
        close: parseFloat(close.toFixed(2)),
        volume: volume
      });
      
      // עדכון מחיר נוכחי לנר הבא
      currentPrice = close;
    }
    
    // הגדרת כל נתוני הדוגמה
    setData(newData);
    
    // הוספת כמה רמות תמיכה/התנגדות מרכזיות
    addSupportResistanceLine(newData[15].low, 'support');
    addSupportResistanceLine(newData[40].high, 'resistance');
    
    // הוספת נקודות חשובות לדוגמה
    setImportantPoints([
      { time: newData[10].time, price: newData[10].high + 350, color: 'red' },
      { time: newData[30].time, price: newData[30].low - 350, color: 'green' }
    ]);
    
    // הגדרת כותרת וסגנון שוק
    setChartTitle('דוגמת BTC/USD - מגמות שוק ריאליסטיות');
    setChartDescription('גרף דמה המדגים דפוסי מחיר מציאותיים בסגנון ביטקוין');
    setChartTags(['bitcoin', 'demo', 'תנודתיות']);
    setMarketStyle('bitcoin');
    
    // זיהוי רמות אוטומטיות
    detectSupportResistanceLevels(newData);
    
    showToast('נתוני דוגמה', 'נטענו 60 נרות בסגנון ביטקוין עם דפוסי שוק מציאותיים', 'success');
  };

  // ========================= פונקציות ציור הגרף =========================

  // ציור נר בודד
  const drawCandle = (ctx, candle, x, width, index, priceScale) => {
    const { open, high, low, close } = candle;
    
    // קביעת צבע נר
    const isBullish = close > open;
    // אפשרות להתאמה אישית עם תמיכה בגרדיאנטים עבור נרות
    let gradientFill;
    if (isBullish) {
      gradientFill = ctx.createLinearGradient(x, 0, x + width, 0);
      gradientFill.addColorStop(0, 'rgba(0, 184, 148, 1)');
      gradientFill.addColorStop(1, 'rgba(0, 206, 165, 1)');
    } else {
      gradientFill = ctx.createLinearGradient(x, 0, x + width, 0);
      gradientFill.addColorStop(0, 'rgba(214, 48, 49, 1)');
      gradientFill.addColorStop(1, 'rgba(232, 65, 66, 1)');
    }
    
    const candleColor = isBullish ? gradientFill : gradientFill;
    const wickColor = '#ffffff';
    
    // קואורדינטות Y לחלקי הנר
    const openY = priceScale(open);
    const closeY = priceScale(close);
    const highY = priceScale(high);
    const lowY = priceScale(low);
    
    // ציור פתיל
    ctx.beginPath();
    ctx.moveTo(x + width/2, highY);
    ctx.lineTo(x + width/2, lowY);
    ctx.strokeStyle = wickColor;
    ctx.lineWidth = 1.5; // פתיל עבה יותר לנראות משופרת
    ctx.stroke();
    
    // ציור גוף
    const bodyTop = Math.min(openY, closeY);
    const bodyHeight = Math.abs(openY - closeY);
    // וידוא גובה מינימלי לנראות
    const minHeight = Math.max(1, width * 0.1);
    const adjustedHeight = Math.max(bodyHeight, minHeight);
    
    // החלת אפקט זוהר על הנר הנבחר
    if (contextMenu.candleIndex === index) {
      ctx.shadowColor = 'var(--accent)';
      ctx.shadowBlur = 15;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
    }
    
    ctx.fillStyle = candleColor;
    
    // גוף הנר עם פינות מעוגלות
    const radius = Math.min(2, width / 4);
    roundRect(ctx, x, bodyTop, width, adjustedHeight, radius);
    ctx.fill();
    
    // איפוס צל
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    
    // ציור גבול סביב גוף הנר
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
    ctx.lineWidth = 1;
    roundRect(ctx, x, bodyTop, width, adjustedHeight, radius);
    ctx.stroke();
    
    // שמירת אזור לחיצה
    return {
      x, 
      y: bodyTop, 
      width, 
      height: adjustedHeight, 
      index,
      candle
    };
  };

  // פונקציית עזר לציור מלבן עם קצוות מעוגלים
  const roundRect = (ctx, x, y, width, height, radius) => {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  };

  // ציור קווי תמיכה/התנגדות
  const drawSupportResistanceLines = (ctx, priceScale, width) => {
    if (!showSupportResistance) return;
    
    // ציור קווי SR ידניים
    supportResistanceLines.forEach(line => {
      const y = priceScale(line.price);
      
      ctx.beginPath();
      ctx.moveTo(chartMargin, y);
      ctx.lineTo(width, y);
      
      // קווים יפים יותר עם גרדיאנט
      let gradient;
      
      if (line.type === 'support') {
        gradient = ctx.createLinearGradient(chartMargin, y, width, y);
        gradient.addColorStop(0, 'rgba(0, 184, 148, 0.1)');
        gradient.addColorStop(0.5, 'rgba(0, 184, 148, 0.7)');
        gradient.addColorStop(1, 'rgba(0, 184, 148, 0.1)');
        ctx.strokeStyle = gradient;
      } else {
        gradient = ctx.createLinearGradient(chartMargin, y, width, y);
        gradient.addColorStop(0, 'rgba(214, 48, 49, 0.1)');
        gradient.addColorStop(0.5, 'rgba(214, 48, 49, 0.7)');
        gradient.addColorStop(1, 'rgba(214, 48, 49, 0.1)');
        ctx.strokeStyle = gradient;
      }
      
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 3]);
      ctx.stroke();
      ctx.setLineDash([]);
      
      // תווית משופרת עם רקע
      const label = line.type === 'support' ? 'תמיכה' : 'התנגדות';
      const price = line.price.toFixed(2);
      const labelText = `${label}: ${price}`;
      const textWidth = ctx.measureText(labelText).width;
      
      // רקע לתווית
      ctx.fillStyle = line.type === 'support' ? 'rgba(0, 184, 148, 0.8)' : 'rgba(214, 48, 49, 0.8)';
      roundRect(ctx, chartMargin + 5, y - 20, textWidth + 10, 20, 3);
      ctx.fill();
      
      // הטקסט עצמו
      ctx.fillStyle = 'white';
      ctx.font = 'bold 12px Arial';
      ctx.textAlign = 'left';
      ctx.fillText(labelText, chartMargin + 10, y - 7);
    });
    
    // ציור רמות שזוהו
    if (data.length > 5) {
      // רמות תמיכה
      supportLevels.forEach(level => {
        const y = priceScale(level.price);
        
        ctx.beginPath();
        ctx.moveTo(chartMargin, y);
        ctx.lineTo(width, y);
        
        // גרדיאנט עבור הקו
        const gradient = ctx.createLinearGradient(chartMargin, y, width, y);
        gradient.addColorStop(0, 'rgba(0, 184, 148, 0.05)');
        gradient.addColorStop(0.5, `rgba(0, 184, 148, ${Math.min(0.2 + level.strength * 0.1, 0.7)})`);
        gradient.addColorStop(1, 'rgba(0, 184, 148, 0.05)');
        
        ctx.strokeStyle = gradient;
        ctx.lineWidth = level.strength;
        ctx.setLineDash([3, 3]);
        ctx.stroke();
        ctx.setLineDash([]);
      });
      
      // רמות התנגדות
      resistanceLevels.forEach(level => {
        const y = priceScale(level.price);
        
        ctx.beginPath();
        ctx.moveTo(chartMargin, y);
        ctx.lineTo(width, y);
        
        // גרדיאנט עבור הקו
        const gradient = ctx.createLinearGradient(chartMargin, y, width, y);
        gradient.addColorStop(0, 'rgba(214, 48, 49, 0.05)');
        gradient.addColorStop(0.5, `rgba(214, 48, 49, ${Math.min(0.2 + level.strength * 0.1, 0.7)})`);
        gradient.addColorStop(1, 'rgba(214, 48, 49, 0.05)');
        
        ctx.strokeStyle = gradient;
        ctx.lineWidth = level.strength;
        ctx.setLineDash([3, 3]);
        ctx.stroke();
        ctx.setLineDash([]);
      });
    }
  };

  // ציור קווי רשת
  const drawGridLines = (ctx, minPrice, maxPrice, priceScale, width, height) => {
    if (!showGridLines) return;
    
    // צבעים משופרים לקווי רשת
    const gridLineColor = 'rgba(255, 255, 255, 0.06)';
    const majorGridLineColor = 'rgba(255, 255, 255, 0.12)';
    
    // ציור קווי רשת אופקיים
    const priceStep = (maxPrice - minPrice) / 10;
    for (let i = 0; i <= 10; i++) {
      const price = minPrice + i * priceStep;
      const y = priceScale(price);
      
      ctx.beginPath();
      ctx.moveTo(chartMargin, y);
      ctx.lineTo(width, y);
      
      // קווים מודגשים יותר לרמות עגולות
      const isRoundPrice = price % 1000 < priceStep || price % 1000 > (1000 - priceStep);
      ctx.strokeStyle = isRoundPrice ? majorGridLineColor : gridLineColor;
      ctx.lineWidth = isRoundPrice ? 1 : 0.5;
      ctx.stroke();
      
      // תוויות מחיר
      if (showPriceLabels) {
        // רקע לתווית
        const priceText = price.toLocaleString('he-IL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        const textWidth = ctx.measureText(priceText).width;
        
        ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
        roundRect(ctx, chartMargin - textWidth - 16, y - 8, textWidth + 8, 16, 2);
        ctx.fill();
        
        // הטקסט עצמו
        ctx.fillStyle = isRoundPrice ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.7)';
        ctx.font = isRoundPrice ? 'bold 12px Arial' : '12px Arial';
        ctx.textAlign = 'right';
        ctx.fillText(priceText, chartMargin - 8, y + 4);
      }
    }
    
    // ציור קווי רשת אנכיים עם שיפורים
    if (data.length > 0) {
      const scaledCandleWidth = candleWidth * zoomLevel;
      const totalChartWidth = data.length * (scaledCandleWidth + candleGap) - candleGap;
      const availableWidth = width - chartMargin;
      
      let offsetX = 0;
      if (totalChartWidth < availableWidth) {
        offsetX = chartMargin + (availableWidth - totalChartWidth) / 2;
      } else {
        offsetX = chartMargin + panOffset;
      }
      
      // קו רשת אנכי כל 5 נרות, עם קווים מודגשים ב-10 נרות
      for (let i = 0; i < data.length; i += 5) {
        const isMajorLine = i % 10 === 0;
        const x = offsetX + i * (scaledCandleWidth + candleGap) + scaledCandleWidth / 2;
        
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height - 20); // השאר מקום לתוויות תאריך
        ctx.strokeStyle = isMajorLine ? majorGridLineColor : gridLineColor;
        ctx.lineWidth = isMajorLine ? 1 : 0.5;
        ctx.stroke();
        
        // תוויות תאריך בתחתית
        if (isMajorLine && data[i]) {
          // רקע לתווית
          const dateStr = formatDateByTimeframe(data[i].time, selectedTimeframe);
          const textWidth = ctx.measureText(dateStr).width;
          
          ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
          roundRect(ctx, x - textWidth / 2 - 4, height - 18, textWidth + 8, 16, 2);
          ctx.fill();
          
          // הטקסט עצמו
          ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
          ctx.font = '11px Arial';
          ctx.textAlign = 'center';
          ctx.fillText(dateStr, x, height - 6);
        }
      }
    }
  };

  // פורמט תאריך בהתאם למסגרת זמן
  const formatDateByTimeframe = (dateStr, timeframe) => {
    const date = new Date(dateStr);
    switch (timeframe) {
      case '15M':
        return `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
      case '1H':
        return `${date.getHours()}:00`;
      case '4H':
        return `${date.getDate()}/${date.getMonth() + 1} ${date.getHours()}:00`;
      case '1W':
        return `שבוע ${Math.ceil(date.getDate() / 7)}/${date.getMonth() + 1}`;
      case '1D':
      default:
        return `${date.getDate()}/${date.getMonth() + 1}`;
    }
  };

  // ציור נקודות חשובות
  const drawImportantPoints = (ctx, priceScale, offsetX, scaledCandleWidth) => {
    if (!importantPoints.length) return;
    
    importantPoints.forEach(point => {
      // מציאת הנר עבור זמן זה
      const candleIndex = data.findIndex(candle => candle.time === point.time);
      if (candleIndex === -1) return;
      
      const x = offsetX + candleIndex * (scaledCandleWidth + candleGap) + scaledCandleWidth / 2;
      const y = priceScale(point.price);
      
      // אפקט זוהר סביב הנקודה
      ctx.shadowColor = point.color || 'red';
      ctx.shadowBlur = 10;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      
      // ציור סמן
      ctx.beginPath();
      ctx.arc(x, y, 8, 0, Math.PI * 2);
      
      // גרדיאנט לנקודות
      const gradient = ctx.createRadialGradient(x, y, 0, x, y, 8);
      gradient.addColorStop(0, point.color || 'red');
      gradient.addColorStop(1, 'rgba(255, 255, 255, 0.6)');
      
      ctx.fillStyle = gradient;
      ctx.fill();
      
      // ציור מתאר
      ctx.strokeStyle = 'white';
      ctx.lineWidth = 2;
      ctx.stroke();
      
      // איפוס צל
      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      
      // ציור קו מהנר לנקודה עם דאש ומראה משודרג
      const candleY = priceScale(data[candleIndex].close);
      
      // קו מהנר לנקודה עם גרדיאנט
      const lineGradient = ctx.createLinearGradient(x, candleY, x, y);
      lineGradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
      lineGradient.addColorStop(0.5, point.color || 'red');
      lineGradient.addColorStop(1, point.color || 'red');
      
      ctx.beginPath();
      ctx.moveTo(x, candleY);
      ctx.lineTo(x, y);
      ctx.strokeStyle = lineGradient;
      ctx.setLineDash([3, 3]);
      ctx.lineWidth = 1.5;
      ctx.stroke();
      ctx.setLineDash([]);
    });
  };

  // ציור הגרף
  const drawChart = (ctx, width, height) => {
    // ניקוי קנבס עם גרדיאנט רקע
    const bgGradient = ctx.createLinearGradient(0, 0, 0, height);
    bgGradient.addColorStop(0, 'rgba(16, 20, 30, 1)');
    bgGradient.addColorStop(1, 'rgba(5, 10, 20, 1)');
    
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, width, height);
    
    // אתחול מערך תיבות נרות ריק
    let newCandleBoxes = [];
    
    // אם אין נתונים, הצג ממלא מקום משודרג
    if (data.length === 0) {
      ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
      roundRect(ctx, width/2 - 250, height/2 - 50, 500, 100, 10);
      ctx.fill();
      
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
      ctx.font = 'bold 20px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('אין נתוני נרות', width / 2, height / 2 - 10);
      
      ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
      ctx.font = '16px Arial';
      ctx.fillText('השתמש בכפתורים בסרגל הצד כדי להוסיף נרות או לטעון דוגמה', width / 2, height / 2 + 20);
      
      setCandleBoxes([]);
      return;
    }
    
    const scaledCandleWidth = candleWidth * zoomLevel;
    const totalChartWidth = data.length * (scaledCandleWidth + candleGap) - candleGap;
    const availableWidth = width - chartMargin;
    
    // חישוב היסט אופקי בהתבסס על מיקום המשיכה
    let offsetX = 0;
    if (totalChartWidth < availableWidth) {
      offsetX = chartMargin + (availableWidth - totalChartWidth) / 2;
    } else {
      // הגבלת משיכה
      const maxPan = 0;
      const minPan = availableWidth - totalChartWidth;
      const constrainedPanOffset = Math.min(maxPan, Math.max(minPan, panOffset));
      setPanOffset(constrainedPanOffset);
      offsetX = chartMargin + constrainedPanOffset;
    }
    
    // מציאת טווח מחירים
    const highs = data.map(c => c.high);
    const lows = data.map(c => c.low);
    const maxPrice = Math.max(...highs) * 1.05; // הוספת שוליים 5%
    const minPrice = Math.min(...lows) * 0.95; // הפחתת שוליים 5%
    
    // יצירת פונקציית קנה מידה מחיר
    const priceScale = price => {
      return height - ((price - minPrice) / (maxPrice - minPrice)) * (height * 0.9) - height * 0.05;
    };
    
    // ציור רשת וצירים
    drawGridLines(ctx, minPrice, maxPrice, priceScale, width, height);
    
    // ציור קווי תמיכה/התנגדות
    drawSupportResistanceLines(ctx, priceScale, width);
    
    // ציור קו ייחוס אם מופעל
    if (showReferenceLine && referencePrice !== null) {
      const refY = priceScale(referencePrice);
      
      // גרדיאנט לקו הייחוס
      const refGradient = ctx.createLinearGradient(chartMargin, refY, width, refY);
      refGradient.addColorStop(0, 'rgba(103, 232, 249, 0.1)');
      refGradient.addColorStop(0.5, 'rgba(103, 232, 249, 0.7)');
      refGradient.addColorStop(1, 'rgba(103, 232, 249, 0.1)');
      
      ctx.beginPath();
      ctx.moveTo(chartMargin, refY);
      ctx.lineTo(width, refY);
      ctx.strokeStyle = refGradient;
      ctx.setLineDash([5, 5]);
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.setLineDash([]);
      
      // הצגת מחיר ייחוס עם רקע לתווית
      const refText = `מחיר ייחוס: ${referencePrice.toFixed(2)}`;
      const textWidth = ctx.measureText(refText).width;
      
      ctx.fillStyle = 'rgba(103, 232, 249, 0.15)';
      roundRect(ctx, chartMargin + 5, refY - 20, textWidth + 10, 20, 5);
      ctx.fill();
      
      ctx.fillStyle = 'rgba(103, 232, 249, 0.9)';
      ctx.font = 'bold 12px Arial';
      ctx.textAlign = 'left';
      ctx.fillText(refText, chartMargin + 10, refY - 6);
    }
    
    // ציור נרות - שימוש בציור מנה (batch) לביצועים משופרים
    data.forEach((candle, index) => {
      const x = offsetX + index * (scaledCandleWidth + candleGap);
      const box = drawCandle(ctx, candle, x, scaledCandleWidth, index, priceScale);
      newCandleBoxes.push(box);
    });
    
    // ציור נקודות חשובות
    drawImportantPoints(ctx, priceScale, offsetX, scaledCandleWidth);
    
    // הוספת מידע על שלב השוק הנוכחי
    if (currentMarketPhase !== 'normal') {
      let phaseText = '';
      let phaseColor = '';
      
      switch (currentMarketPhase) {
        case 'trending':
          phaseText = 'מגמה חזקה';
          phaseColor = 'rgba(103, 232, 249, 0.9)';
          break;
        case 'volatile':
          phaseText = 'תנודתיות גבוהה';
          phaseColor = 'rgba(250, 204, 21, 0.9)';
          break;
        case 'reversing':
          phaseText = 'היפוך מגמה פוטנציאלי';
          phaseColor = 'rgba(239, 68, 68, 0.9)';
          break;
      }
      
      if (phaseText) {
        const textWidth = ctx.measureText(phaseText).width;
        
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        roundRect(ctx, width - textWidth - 20, 10, textWidth + 10, 24, 4);
        ctx.fill();
        
        ctx.fillStyle = phaseColor;
        ctx.font = 'bold 12px Arial';
        ctx.textAlign = 'right';
        ctx.fillText(phaseText, width - 15, 26);
      }
    }
    
    // עדכון מערך תיבות נרות לזיהוי לחיצות
    setCandleBoxes(newCandleBoxes);
  };

  // ========================= רכיבי UI וטיפול באירועים =========================

  // טיפול בגלגלת עכבר (זום)
  const handleWheel = (event) => {
    event.preventDefault();
    
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    
    // מציאת מיקום יחסי לפני זום
    const scaledCandleWidth = candleWidth * zoomLevel;
    const totalChartWidth = data.length * (scaledCandleWidth + candleGap) - candleGap;
    const availableWidth = canvas.width - chartMargin;
    
    let offsetX = chartMargin;
    if (totalChartWidth < availableWidth) {
      offsetX = chartMargin + (availableWidth - totalChartWidth) / 2;
    } else {
      offsetX = chartMargin + panOffset;
    }
    
    const relativeMousePos = (mouseX - offsetX) / totalChartWidth;
    
    // התאמת רמת זום
    if (event.deltaY < 0) {
      setZoomLevel(prev => Math.min(5, prev * 1.1)); // הגבלת זום מקסימלי
    } else {
      setZoomLevel(prev => Math.max(0.3, prev / 1.1)); // הגבלת זום מינימלי
    }
    
    // חישוב מיקום חדש
    const newScaledCandleWidth = candleWidth * zoomLevel;
    const newTotalChartWidth = data.length * (newScaledCandleWidth + candleGap) - candleGap;
    
    if (newTotalChartWidth >= availableWidth) {
      // התאמת משיכה לשמירת העכבר מעל אותו נר
      setPanOffset(prev => mouseX - (relativeMousePos * newTotalChartWidth) - chartMargin);
    }
  };

  // טיפול בלחיצת עכבר למטה
  const handleMouseDown = (event) => {
    if (event.button === 0) { // לחצן עכבר שמאלי
      setIsDragging(true);
      setDragStartX(event.clientX);
      setDragStartPanOffset(panOffset);
      event.currentTarget.style.cursor = 'grabbing';
    }
  };

  // טיפול בתזוזת עכבר
  const handleMouseMove = (event) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    if (isDragging) {
      const deltaX = event.clientX - dragStartX;
      setPanOffset(dragStartPanOffset + deltaX);
    } else {
      // בדיקת מעבר עכבר מעל נר לטולטיפ
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      
      let hoveredCandle = null;
      for (const box of candleBoxes) {
        if (
          mouseX >= box.x && 
          mouseX <= box.x + box.width &&
          mouseY >= box.y - 10 && // הרחבת אזור הפגיעה מעט מעל גוף הנר
          mouseY <= box.y + box.height + 10 // והרחבה מתחת
        ) {
          hoveredCandle = box;
          break;
        }
      }
      
      if (hoveredCandle) {
        // אם המשתמש מסמן נקודה חשובה
        if (isMarkingImportantPoint) {
          // נייצר נקודה חשובה במיקום הנוכחי של העכבר
          addImportantPoint(
            hoveredCandle.candle.time,
            // נשתמש בגובה היחסי של העכבר כדי לקבוע את המחיר
            hoveredCandle.candle.low + 
              (hoveredCandle.candle.high - hoveredCandle.candle.low) * 
              ((hoveredCandle.y + hoveredCandle.height - mouseY) / hoveredCandle.height)
          );
        } else {
          // אחרת רק נציג טולטיפ מחיר
          setPriceInfo({
            visible: true,
            x: event.clientX,
            y: event.clientY,
            candle: hoveredCandle.candle
          });
        }
      } else {
        setPriceInfo({ visible: false });
      }
    }
  };

  // טיפול בשחרור לחצן עכבר
  const handleMouseUp = () => {
    setIsDragging(false);
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.style.cursor = 'grab';
    }
  };

  // טיפול ביציאת עכבר מהקנבס
  const handleMouseLeave = () => {
    setIsDragging(false);
    setPriceInfo({ visible: false });
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.style.cursor = 'grab';
    }
  };

  // טיפול בלחיצה ימנית על נר להצגת תפריט הקשר
  const handleContextMenu = (event) => {
    event.preventDefault();
    
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const rect = canvas.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;
    
    // בדיקה אם הלחיצה היא על נר
    for (const box of candleBoxes) {
      if (
        clickX >= box.x && 
        clickX <= box.x + box.width &&
        clickY >= box.y &&
        clickY <= box.y + box.height
      ) {
        // נמצא הנר עליו לחצו
        setContextMenu({
          visible: true,
          x: event.clientX,
          y: event.clientY,
          candleIndex: box.index
        });
        break;
      }
    }
  };

  // סגירת תפריט הקשר
  const closeContextMenu = () => {
    setContextMenu({ visible: false });
  };

  // פתיחת מודל עריכת נר
  const openEditCandleModal = (index) => {
    setSelectedCandleIndex(index);
    setIsEditModalOpen(true);
    closeContextMenu();
  };

  // שמירת נר לאחר עריכה
  const saveEditedCandle = (updatedCandle) => {
    if (selectedCandleIndex === null) return;
    
    const newData = [...data];
    newData[selectedCandleIndex] = updatedCandle;
    setData(newData);
    
    setIsEditModalOpen(false);
    setSelectedCandleIndex(null);
    
    showToast('עריכת נר', 'השינויים נשמרו בהצלחה', 'success');
  };

  // ========================= איזור רינדור הקומפוננטה =========================
  
  return (
    <div className="app-container dark-crypto-pro" dir="rtl">
      {/* כותרת */}
      <header className="header">
        <div className="logo">
          <span className="logo-icon">
            <Sparkles />
          </span>
          <h1>DARK<span className="accent">CRYPTO</span> <span className="pro-badge">PRO</span></h1>
        </div>
        
        <div className="header-controls">
          <div className="chart-info">
            {chartTitle && <h2>{chartTitle}</h2>}
            <div className="price-badge">
              <span className="current-price">{data.length > 0 ? formatNumber(data[data.length-1].close) : '0.00'}</span>
              
              {data.length > 1 && (
                <span className={getPercentageChange().isUp ? 'price-change up' : 'price-change down'}>
                  {getPercentageChange().isUp ? '▲' : '▼'} {getPercentageChange().value}%
                </span>
              )}
            </div>
          </div>
          
          <div className="timeframe-selector">
            <button className={selectedTimeframe === '15M' ? 'active' : ''} onClick={() => setSelectedTimeframe('15M')}>15D</button>
            <button className={selectedTimeframe === '1H' ? 'active' : ''} onClick={() => setSelectedTimeframe('1H')}>1S</button>
            <button className={selectedTimeframe === '4H' ? 'active' : ''} onClick={() => setSelectedTimeframe('4H')}>4S</button>
            <button className={selectedTimeframe === '1D' ? 'active' : ''} onClick={() => setSelectedTimeframe('1D')}>1I</button>
            <button className={selectedTimeframe === '1W' ? 'active' : ''} onClick={() => setSelectedTimeframe('1W')}>1SB</button>
          </div>
          
          <div className="controls-group">
            {user ? (
              <div className="user-profile">
                <span className="user-name">{user.displayName || user.email}</span>
                <button className="user-button" onClick={() => setIsUserSettingsOpen(!isUserSettingsOpen)}>
                  <User />
                  {notificationCount > 0 && <span className="notification-badge">{notificationCount}</span>}
                </button>
                {isUserSettingsOpen && (
                  <div className="user-dropdown">
                    <div className="user-dropdown-header">
                      <span className="user-email">{user.email}</span>
                    </div>
                    <div className="user-dropdown-content">
                      <button onClick={() => fetchSavedCharts()}>
                        <Save /> הגרפים שלי
                      </button>
                      <button onClick={() => setIsSavedChartsOpen(true)}>
                        <DownloadCloud /> טען גרף
                      </button>
                      <button onClick={saveChartToFirebase}>
                        <Upload /> שמור גרף
                      </button>
                      <div className="dropdown-divider"></div>
                      <button onClick={() => setIsUserSettingsOpen(false)}>
                        <Settings /> הגדרות
                      </button>
                      <button onClick={handleLogout} className="logout-button">
                        <LogOut /> התנתק
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <button className="login-button" onClick={handleLogin}>
                <User />
                <span>התחבר</span>
              </button>
            )}
            
            <button className="tool-button" onClick={() => saveChartToFirebase()}>
              <Save />
              <span className="tooltip">שמור גרף</span>
            </button>
            <button className="tool-button" onClick={() => setIsSavedChartsOpen(true)}>
              <DownloadCloud />
              <span className="tooltip">טען גרף</span>
            </button>
            <button className="tool-button" onClick={() => setImageUploadOpen(true)}>
              <Image />
              <span className="tooltip">זיהוי מתמונה</span>
            </button>
            <button className="tool-button" onClick={() => setIsHelpModalOpen(true)}>
              <AlertCircle />
              <span className="tooltip">עזרה</span>
            </button>
            <button className="tool-button" onClick={toggleSidebar}>
              {sidebarCollapsed ? <ChevronRight /> : <ChevronDown />}
              <span className="tooltip">{sidebarCollapsed ? 'הצג סרגל צד' : 'הסתר סרגל צד'}</span>
            </button>
          </div>
        </div>
      </header>

      {/* אזור תוכן ראשי */}
      <div className="content-area">
        {/* סרגל צד */}
        <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="sidebar-tabs">
            <button 
              className={activeTab === 'candles' ? 'active' : ''} 
              onClick={() => setActiveTab('candles')}
            >
              <i className="icon"><Candlestick /></i>
              <span>נרות</span>
            </button>
            <button 
              className={activeTab === 'market' ? 'active' : ''} 
              onClick={() => setActiveTab('market')}
            >
              <i className="icon"><TrendingUp /></i>
              <span>שוק</span>
            </button>
            <button 
              className={activeTab === 'chart' ? 'active' : ''} 
              onClick={() => setActiveTab('chart')}
            >
              <i className="icon"><Settings /></i>
              <span>הגדרות</span>
            </button>
            <button 
              className={activeTab === 'tools' ? 'active' : ''} 
              onClick={() => setActiveTab('tools')}
            >
              <i className="icon"><Layers /></i>
              <span>כלים</span>
            </button>
          </div>
          
          <div className="sidebar-content">
            {activeTab === 'candles' && (
              <div className="tab-content">
                <div className="section">
                  <h3 className="section-title">הוספת נרות</h3>
                  <div className="candle-grid">
                    {/* נרות עולים */}
                    <button className="candle-btn bullish" onClick={() => addCandle('up', 'small', true)}>
                      <div className="candle-icon small solid"></div>
                      <span>נר עולה קטן</span>
                    </button>
                    <button className="candle-btn bullish" onClick={() => addCandle('up', 'small', false)}>
                      <div className="candle-icon small"></div>
                      <span>נר עולה עם פתיל</span>
                    </button>
                    <button className="candle-btn bullish" onClick={() => addCandle('up', 'large', true)}>
                      <div className="candle-icon large solid"></div>
                      <span>נר עולה גדול</span>
                    </button>
                    <button className="candle-btn bullish" onClick={() => addCandle('up', 'large', false)}>
                      <div className="candle-icon large"></div>
                      <span>נר עולה גדול עם פתיל</span>
                    </button>
                    
                    {/* נרות יורדים */}
                    <button className="candle-btn bearish" onClick={() => addCandle('down', 'small', true)}>
                      <div className="candle-icon small solid"></div>
                      <span>נר יורד קטן</span>
                    </button>
                    <button className="candle-btn bearish" onClick={() => addCandle('down', 'small', false)}>
                      <div className="candle-icon small"></div>
                      <span>נר יורד עם פתיל</span>
                    </button>
                    <button className="candle-btn bearish" onClick={() => addCandle('down', 'large', true)}>
                      <div className="candle-icon large solid"></div>
                      <span>נר יורד גדול</span>
                    </button>
                    <button className="candle-btn bearish" onClick={() => addCandle('down', 'large', false)}>
                      <div className="candle-icon large"></div>
                      <span>נר יורד גדול עם פתיל</span>
                    </button>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">סימולציה</h3>
                  <div className="controls-wrapper">
                    <div className="simulation-controls">
                      <button 
                        className={`control-btn ${isPlaying ? 'active' : ''}`}
                        onClick={toggleSimulation}
                      >
                        {isPlaying ? <PauseCircle /> : <PlayCircle />}
                        <span>{isPlaying ? 'עצור' : 'הפעל'}</span>
                      </button>
                      <button 
                        className="control-btn"
                        onClick={() => removeLastCandles(1)}
                        disabled={data.length === 0}
                      >
                        <MinusCircle />
                        <span>הסר אחרון</span>
                      </button>
                      <button 
                        className="control-btn danger"
                        onClick={clearAllCandles}
                        disabled={data.length === 0}
                      >
                        <TrashCan />
                        <span>נקה הכל</span>
                      </button>
                      <button 
                        className="control-btn highlight"
                        onClick={loadSampleData}
                      >
                        <RefreshCircle />
                        <span>טען דוגמה</span>
                      </button>
                    </div>
                    
                    <div className="speed-control">
                      <span className="label">מהירות:</span>
                      <div className="speed-indicator">
                        {[1, 2, 3, 4, 5].map(i => (
                          <div 
                            key={i}
                            className={`speed-bar ${i <= simulationSpeed ? 'active' : ''}`}
                            onClick={() => setSimulationSpeed(i)}
                          ></div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">נקודות חשובות</h3>
                  <div className="important-points">
                    <button 
                      className={`mark-point-btn ${isMarkingImportantPoint ? 'active' : ''}`}
                      onClick={() => setIsMarkingImportantPoint(!isMarkingImportantPoint)}
                    >
                      <TargetPoint />
                      <span>{isMarkingImportantPoint ? 'בטל סימון' : 'סמן נקודה חשובה'}</span>
                    </button>
                    
                    <div className="point-colors">
                      <span className="label">צבע:</span>
                      <div 
                        className={`color-option red ${importantPointColor === 'red' ? 'selected' : ''}`}
                        onClick={() => setImportantPointColor('red')}
                      ></div>
                      <div 
                        className={`color-option green ${importantPointColor === 'green' ? 'selected' : ''}`}
                        onClick={() => setImportantPointColor('green')}
                      ></div>
                      <div 
                        className={`color-option blue ${importantPointColor === 'blue' ? 'selected' : ''}`}
                        onClick={() => setImportantPointColor('blue')}
                      ></div>
                      <div 
                        className={`color-option gold ${importantPointColor === 'gold' ? 'selected' : ''}`}
                        onClick={() => setImportantPointColor('gold')}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeTab === 'market' && (
              <div className="tab-content">
                <div className="section">
                  <h3 className="section-title">סגנון שוק</h3>
                  <div className="market-style-options">
                    <label className={`market-option ${marketStyle === 'bitcoin' ? 'selected' : ''}`}>
                      <input 
                        type="radio" 
                        name="marketStyle" 
                        value="bitcoin" 
                        checked={marketStyle === 'bitcoin'} 
                        onChange={() => setMarketStyle('bitcoin')}
                      />
                      <span className="option-content">
                        <i className="option-icon"><Sparkles /></i>
                        <span className="option-label">ביטקוין</span>
                        <span className="option-desc">תנודתיות גבוהה</span>
                      </span>
                    </label>
                    
                    <label className={`market-option ${marketStyle === 'stock' ? 'selected' : ''}`}>
                      <input 
                        type="radio" 
                        name="marketStyle" 
                        value="stock" 
                        checked={marketStyle === 'stock'} 
                        onChange={() => setMarketStyle('stock')}
                      />
                      <span className="option-content">
                        <i className="option-icon"><TrendingUp /></i>
                        <span className="option-label">מניות</span>
                        <span className="option-desc">תנודתיות בינונית</span>
                      </span>
                    </label>
                    
                    <label className={`market-option ${marketStyle === 'forex' ? 'selected' : ''}`}>
                      <input 
                        type="radio" 
                        name="marketStyle" 
                        value="forex" 
                        checked={marketStyle === 'forex'} 
                        onChange={() => setMarketStyle('forex')}
                      />
                      <span className="option-content">
                        <i className="option-icon"><DollarSign /></i>
                        <span className="option-label">פורקס</span>
                        <span className="option-desc">תנודתיות נמוכה</span>
                      </span>
                    </label>
                    
                    <label className={`market-option ${marketStyle === 'random' ? 'selected' : ''}`}>
                      <input 
                        type="radio" 
                        name="marketStyle" 
                        value="random" 
                        checked={marketStyle === 'random'} 
                        onChange={() => setMarketStyle('random')}
                      />
                      <span className="option-content">
                        <i className="option-icon"><RefreshCircle /></i>
                        <span className="option-label">אקראי</span>
                        <span className="option-desc">ללא דפוס קבוע</span>
                      </span>
                    </label>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">מגמה כללית</h3>
                  <div className="trend-control">
                    <div className="trend-labels">
                      <span>יורד</span>
                      <span>ניטרלי</span>
                      <span>עולה</span>
                    </div>
                    <div className="trend-slider-container">
                      <input 
                        type="range" 
                        min="0" 
                        max="100" 
                        value={trendBias}
                        onChange={(e) => setTrendBias(parseInt(e.target.value))}
                        className="trend-slider"
                      />
                      <div 
                        className="trend-indicator"
                        style={{ 
                          left: `${trendBias}%`,
                          backgroundColor: trendBias > 60 ? 'var(--bullish)' : 
                                          trendBias < 40 ? 'var(--bearish)' : 
                                          'var(--neutral)'
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">רמת תנודתיות</h3>
                  <div className="volatility-control">
                    <div className="volatility-slider-container">
                      <input 
                        type="range"
                        min="1"
                        max="5"
                        value={volatilityLevel}
                        onChange={(e) => setVolatilityLevel(parseInt(e.target.value))}
                        className="volatility-slider"
                      />
                    </div>
                    <div className="volatility-indicator">
                      {[1, 2, 3, 4, 5].map(i => (
                        <div 
                          key={i}
                          className={`volatility-bar ${i <= volatilityLevel ? 'active' : ''}`}
                          style={{ height: `${i * 4}px` }}
                        ></div>
                      ))}
                    </div>
                    <div className="volatility-labels">
                      <span>נמוכה</span>
                      <span>בינונית</span>
                      <span>גבוהה</span>
                    </div>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">שלב שוק נוכחי</h3>
                  <div className="market-phase">
                    <div className={`phase-badge ${currentMarketPhase}`}>
                      {currentMarketPhase === 'normal' && <span>רגיל</span>}
                      {currentMarketPhase === 'trending' && <span>מגמתי</span>}
                      {currentMarketPhase === 'volatile' && <span>תנודתי</span>}
                      {currentMarketPhase === 'reversing' && <span>היפוך</span>}
                    </div>
                    <div className="phase-desc">
                      {currentMarketPhase === 'normal' && <span>התנהגות שוק רגילה</span>}
                      {currentMarketPhase === 'trending' && <span>תנועת מחיר במגמה חזקה</span>}
                      {currentMarketPhase === 'volatile' && <span>תנודתיות מוגברת ללא כיוון ברור</span>}
                      {currentMarketPhase === 'reversing' && <span>אינדיקציות להיפוך מגמה</span>}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeTab === 'chart' && (
              <div className="tab-content">
                <div className="section">
                  <h3 className="section-title">מראה גרף</h3>
                  <div className="chart-visual-settings">
                    <div className="setting-group">
                      <label className="slider-label">רוחב נר</label>
                      <div className="slider-control">
                        <input 
                          type="range"
                          min="5"
                          max="30"
                          value={candleWidth}
                          onChange={(e) => setCandleWidth(parseInt(e.target.value))}
                          className="setting-slider"
                        />
                        <span className="slider-value">{candleWidth}px</span>
                      </div>
                    </div>
                    
                    <div className="setting-group">
                      <label className="slider-label">מרווח בין נרות</label>
                      <div className="slider-control">
                        <input 
                          type="range"
                          min="1"
                          max="15"
                          value={candleGap}
                          onChange={(e) => setCandleGap(parseInt(e.target.value))}
                          className="setting-slider"
                        />
                        <span className="slider-value">{candleGap}px</span>
                      </div>
                    </div>
                    
                    <div className="setting-group">
                      <label className="slider-label">רמת זום</label>
                      <div className="slider-control">
                        <input 
                          type="range"
                          min="0.5"
                          max="3"
                          step="0.1"
                          value={zoomLevel}
                          onChange={(e) => setZoomLevel(parseFloat(e.target.value))}
                          className="setting-slider"
                        />
                        <span className="slider-value">x{zoomLevel.toFixed(1)}</span>
                      </div>
                    </div>
                    
                    <div className="toggle-settings">
                      <label className="toggle-setting">
                        <span>הצג קווי רשת</span>
                        <label className="toggle-switch">
                          <input 
                            type="checkbox"
                            checked={showGridLines}
                            onChange={(e) => setShowGridLines(e.target.checked)}
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </label>
                      
                      <label className="toggle-setting">
                        <span>הצג תוויות מחיר</span>
                        <label className="toggle-switch">
                          <input 
                            type="checkbox"
                            checked={showPriceLabels}
                            onChange={(e) => setShowPriceLabels(e.target.checked)}
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </label>
                      
                      <label className="toggle-setting">
                        <span>הצג תמיכה/התנגדות</span>
                        <label className="toggle-switch">
                          <input 
                            type="checkbox"
                            checked={showSupportResistance}
                            onChange={(e) => setShowSupportResistance(e.target.checked)}
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </label>
                      
                      <label className="toggle-setting">
                        <span>הצג קו ייחוס</span>
                        <label className="toggle-switch">
                          <input 
                            type="checkbox"
                            checked={showReferenceLine}
                            onChange={(e) => {
                              setShowReferenceLine(e.target.checked);
                              if (e.target.checked && referencePrice === null && data.length > 0) {
                                // הגדר מחיר ייחוס ראשוני לממוצע של המחירים בגרף
                                const avg = data.reduce((sum, candle) => sum + candle.close, 0) / data.length;
                                setReferencePrice(avg);
                              }
                            }}
                          />
                          <span className="toggle-slider"></span>
                        </label>
                      </label>
                    </div>
                    
                    {showReferenceLine && (
                      <div className="setting-group">
                        <label className="slider-label">מחיר ייחוס</label>
                        <div className="slider-control">
                          <input 
                            type="number"
                            value={referencePrice || 0}
                            onChange={(e) => setReferencePrice(parseFloat(e.target.value))}
                            className="reference-price-input"
                            step="10"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">מידע גרף</h3>
                  <div className="chart-info-settings">
                    <div className="input-group">
                      <label>כותרת</label>
                      <input 
                        type="text"
                        value={chartTitle}
                        onChange={(e) => setChartTitle(e.target.value)}
                        placeholder="הזן כותרת לגרף"
                        className="chart-title-input"
                      />
                    </div>
                    
                    <div className="input-group">
                      <label>תיאור</label>
                      <textarea 
                        value={chartDescription}
                        onChange={(e) => setChartDescription(e.target.value)}
                        placeholder="הוסף תיאור לגרף זה"
                        className="chart-description-input"
                        rows="3"
                      ></textarea>
                    </div>
                    
                    <div className="input-group">
                      <label>תגיות</label>
                      <div className="tags-input-container">
                        <div className="tags-display">
                          {chartTags.map((tag, index) => (
                            <div key={index} className="tag">
                              <span>{tag}</span>
                              <button 
                                className="remove-tag" 
                                onClick={() => setChartTags(prev => prev.filter((_, i) => i !== index))}
                              >×</button>
                            </div>
                          ))}
                        </div>
                        <input 
                          type="text"
                          placeholder="הוסף תגיות ולחץ Enter"
                          className="tags-input"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && e.target.value.trim()) {
                              setChartTags(prev => [...prev, e.target.value.trim()]);
                              e.target.value = '';
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                    
                    <div className="input-group chart-level">
                      <label>רמת מורכבות</label>
                      <div className="level-selector">
                        {[1, 2, 3, 4, 5].map(level => (
                          <button
                            key={level}
                            className={`level-btn ${chartLevel === level ? 'selected' : ''}`}
                            onClick={() => setChartLevel(level)}
                          >
                            <Award />
                            <span>{level}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    <div className="toggle-setting public-toggle">
                      <span>גרף ציבורי</span>
                      <label className="toggle-switch">
                        <input 
                          type="checkbox"
                          checked={isPublic}
                          onChange={(e) => setIsPublic(e.target.checked)}
                        />
                        <span className="toggle-slider"></span>
                      </label>
                      <span className="info-tooltip">
                        <InfoCircle />
                        <span className="tooltip-text">גרפים ציבוריים ניתנים לצפייה על ידי כל משתמש</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeTab === 'tools' && (
              <div className="tab-content">
                <div className="section">
                  <h3 className="section-title">כלי ניתוח</h3>
                  <div className="tools-grid">
                    <button className={`tool-item ${activeTool === 'trendline' ? 'active' : ''}`} onClick={() => setActiveTool(activeTool === 'trendline' ? null : 'trendline')}>
                      <i className="tool-icon"><TrendingUp /></i>
                      <span>קו מגמה</span>
                    </button>
                    <button className={`tool-item ${activeTool === 'support' ? 'active' : ''}`} onClick={() => setActiveTool(activeTool === 'support' ? null : 'support')}>
                      <i className="tool-icon"><ArrowUp /></i>
                      <span>תמיכה</span>
                    </button>
                    <button className={`tool-item ${activeTool === 'resistance' ? 'active' : ''}`} onClick={() => setActiveTool(activeTool === 'resistance' ? null : 'resistance')}>
                      <i className="tool-icon"><ArrowDown /></i>
                      <span>התנגדות</span>
                    </button>
                    <button className={`tool-item ${activeTool === 'reference' ? 'active' : ''}`} onClick={() => {
                      setActiveTool(activeTool === 'reference' ? null : 'reference');
                      setShowReferenceLine(true);
                    }}>
                      <i className="tool-icon"><TargetPoint /></i>
                      <span>מחיר ייחוס</span>
                    </button>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">זיהוי תבניות</h3>
                  <div className="pattern-recognition">
                    <button className="pattern-btn" onClick={() => {
                      // הפעלת אלגוריתם לזיהוי תבניות בנתונים הקיימים
                      if (data.length < 10) {
                        showToast('זיהוי תבניות', 'נדרשים לפחות 10 נרות לזיהוי תבניות', 'warning');
                        return;
                      }
                      
                      // במקום זה יהיה קוד אמיתי לזיהוי תבניות
                      // לדוגמה אנחנו רק מציגים התראה
                      showToast('זיהוי תבניות', 'המערכת מבצעת סריקה של תבניות מחיר...', 'info');
                      
                      // סימולציה של זיהוי דפוסים לאחר השהיה
                      setTimeout(() => {
                        const patterns = [
                          { name: 'דוג׳י', position: data.length - 3, importance: 'medium' },
                          { name: 'הרמוני', position: data.length - 7, importance: 'high' }
                        ];
                        
                        // הוספת סימונים לנקודות החשובות (אם יש)
                        if (patterns.length > 0) {
                          patterns.forEach(pattern => {
                            if (pattern.importance === 'high') {
                              addImportantPoint(
                                data[pattern.position].time,
                                data[pattern.position].high + 200,
                                'gold'
                              );
                            }
                          });
                          
                          showToast('זיהוי תבניות', `זוהו ${patterns.length} תבניות מחיר אפשריות`, 'success');
                        } else {
                          showToast('זיהוי תבניות', 'לא זוהו תבניות מחיר משמעותיות', 'info');
                        }
                      }, 1500);
                    }}>
                      <i className="pattern-icon"><Chart /></i>
                      <span>זהה תבניות מחיר</span>
                    </button>
                    
                    <div className="pattern-info">
                      <span className="info-text">זיהוי אוטומטי של תבניות מחיר נפוצות בגרף הנוכחי.</span>
                    </div>
                  </div>
                </div>
                
                <div className="section">
                  <h3 className="section-title">שיתוף גרף</h3>
                  <div className="sharing-tools">
                    <button className="share-btn" onClick={() => {
                      if (!user) {
                        showToast('שיתוף', 'עליך להתחבר כדי לשתף גרף', 'warning');
                        return;
                      }
                      
                      if (data.length === 0) {
                        showToast('שיתוף', 'אין נתונים לשיתוף', 'warning');
                        return;
                      }
                      
                      // שמירת הגרף כציבורי ויצירת לינק שיתוף
                      setIsPublic(true);
                      saveChartToFirebase().then(() => {
                        setIsShareModalOpen(true);
                      });
                    }}>
                      <i className="share-icon"><Upload /></i>
                      <span>שתף גרף</span>
                    </button>
                    
                    <div className="share-info">
                      <span className="info-text">שיתוף הגרף יאפשר לאחרים לצפות בו באמצעות קישור.</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* אזור גרף */}
        <div className="chart-area">
          <div className="chart-container">
            <canvas 
              ref={canvasRef}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseLeave}
              onWheel={handleWheel}
              onContextMenu={handleContextMenu}
              style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
            />
            
            {/* טולטיפ מחיר */}
            {priceInfo.visible && priceInfo.candle && (
              <div 
                className="price-tooltip" 
                style={{ 
                  left: `${priceInfo.x + 15}px`,
                  top: `${priceInfo.y - 10}px`
                }}
              >
                <div className="tooltip-header">
                  <span className="tooltip-date">{new Date(priceInfo.candle.time).toLocaleDateString()}</span>
                </div>
                <div className="tooltip-body">
                  <div className="tooltip-row">
                    <span className="tooltip-label">פתיחה:</span>
                    <span className="tooltip-value">{priceInfo.candle.open.toLocaleString('he-IL', { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="tooltip-row">
                    <span className="tooltip-label">גבוה:</span>
                    <span className="tooltip-value">{priceInfo.candle.high.toLocaleString('he-IL', { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="tooltip-row">
                    <span className="tooltip-label">נמוך:</span>
                    <span className="tooltip-value">{priceInfo.candle.low.toLocaleString('he-IL', { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="tooltip-row">
                    <span className="tooltip-label">סגירה:</span>
                    <span className="tooltip-value">{priceInfo.candle.close.toLocaleString('he-IL', { minimumFractionDigits: 2 })}</span>
                  </div>
                  <div className="tooltip-row">
                    <span className="tooltip-label">שינוי:</span>
                    <span className={`tooltip-value ${priceInfo.candle.close >= priceInfo.candle.open ? 'positive' : 'negative'}`}>
                      {priceInfo.candle.close >= priceInfo.candle.open ? '▲' : '▼'} 
                      {Math.abs(priceInfo.candle.close - priceInfo.candle.open).toLocaleString('he-IL', { minimumFractionDigits: 2 })} 
                      ({((Math.abs(priceInfo.candle.close - priceInfo.candle.open) / priceInfo.candle.open) * 100).toFixed(2)}%)
                    </span>
                  </div>
                  <div className="tooltip-row">
                    <span className="tooltip-label">נפח:</span>
                    <span className="tooltip-value">{priceInfo.candle.volume?.toLocaleString() || 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
            
            {/* אזור העלאת תמונה */}
            {imageUploadOpen && (
              <div className="image-upload-overlay">
                <div className="image-upload-card">
                  <div className="upload-header">
                    <h3>העלאת תמונת גרף לזיהוי</h3>
                    <button className="close-button" onClick={() => setImageUploadOpen(false)}>×</button>
                  </div>
                  
                  <div className="upload-content">
                    <p className="upload-instructions">העלה תמונה של גרף נרות והמערכת תנסה לזהות את הנרות באופן אוטומטי</p>
                    
                    <div className="upload-area">
                      {!imagePreview ? (
                        <div className="upload-placeholder">
                          <i className="upload-icon"><Image /></i>
                          <span>גרור תמונה לכאן או לחץ לבחירה</span>
                          <input 
                            type="file" 
                            className="file-input" 
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                  setImagePreview(e.target.result);
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <div className="preview-container">
                          <img 
                            src={imagePreview} 
                            alt="תצוגה מקדימה" 
                            className="image-preview"
                          />
                          <button 
                            className="remove-preview"
                            onClick={() => setImagePreview(null)}
                          >
                            <TrashCan />
                          </button>
                        </div>
                      )}
                    </div>
                    
                    {imagePreview && (
                      <div className="upload-actions">
                        <button 
                          className="process-image-btn"
                          onClick={() => {
                            showToast('מעבד תמונה', 'מזהה נרות מהתמונה...', 'info');
                            
                            // סימולציה של עיבוד תמונה
                            setTimeout(() => {
                              // ניקוי נתונים קיימים
                              setData([]);
                              
                              // יצירת נתוני דוגמה במקום זיהוי מתמונה אמיתי
                              let initialPrice = 30120;
                              let currentPrice = initialPrice;
                              let newData = [];
                              const candleCount = 15 + Math.floor(Math.random() * 10);
                              const overallTrend = Math.random() > 0.5 ? 'uptrend' : 'downtrend';
                              
                              for (let i = 0; i < candleCount; i++) {
                                const isUp = overallTrend === 'uptrend' ? 
                                              Math.random() > 0.3 : 
                                              Math.random() > 0.7;
                                
                                const open = currentPrice;
                                const volatility = 250 + Math.random() * 400;
                                const close = isUp ? 
                                             open + Math.random() * volatility : 
                                             open - Math.random() * volatility;
                                
                                const highExtra = Math.random() * 200;
                                const lowExtra = Math.random() * 200;
                                
                                const high = Math.max(open, close) + highExtra;
                                const low = Math.min(open, close) - lowExtra;
                                
                                const date = new Date();
                                date.setDate(date.getDate() - (candleCount - i));
                                
                                const volume = 500 + Math.floor(Math.random() * 1500);
                                
                                newData.push({
                                  time: date.toISOString().split('T')[0],
                                  open: parseFloat(open.toFixed(2)),
                                  high: parseFloat(high.toFixed(2)),
                                  low: parseFloat(low.toFixed(2)),
                                  close: parseFloat(close.toFixed(2)),
                                  volume: volume
                                });
                                
                                currentPrice = close;
                              }
                              
                              setData(newData);
                              setChartTitle('גרף שזוהה מתמונה');
                              setChartDescription('גרף שנוצר באמצעות זיהוי נרות מתמונה');
                              
                              // זיהוי רמות תמיכה/התנגדות פוטנציאליות
                              detectSupportResistanceLevels(newData);
                              
                              showToast('זיהוי הושלם', `זוהו ${newData.length} נרות מהתמונה`, 'success');
                              
                              // סגירת חלון העלאה
                              setImageUploadOpen(false);
                              setImagePreview(null);
                            }, 2000);
                          }}
                        >
                          <i className="btn-icon"><Chart /></i>
                          <span>זהה נרות מהתמונה</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            
            {/* תפריט הקשר */}
            {contextMenu.visible && (
              <div 
                className="context-menu" 
                style={{ 
                  left: `${contextMenu.x}px`,
                  top: `${contextMenu.y}px`
                }}
              >
                <div 
                  className="context-menu-item" 
                  onClick={() => {
                    if (contextMenu.candleIndex !== null) {
                      openEditCandleModal(contextMenu.candleIndex);
                    }
                  }}
                >
                  <i className="item-icon"><Settings /></i>
                  <span>ערוך נר</span>
                </div>
                <div 
                  className="context-menu-item"
                  onClick={() => {
                    if (contextMenu.candleIndex !== null) {
                      const candle = data[contextMenu.candleIndex];
                      
                      // בדיקה אם הנר התקבל
                      const recentCandles = data.slice(Math.max(0, data.length - 10));
                      const recentLows = recentCandles.map(c => c.low);
                      const avgLow = recentLows.reduce((a, b) => a + b, 0) / recentLows.length;
                      
                      const type = candle.low < avgLow ? 'support' : 'resistance';
                      const price = type === 'support' ? candle.low : candle.high;
                      
                      addSupportResistanceLine(price, type);
                      closeContextMenu();
                      
                      showToast('קו חדש', `נוסף קו ${type === 'support' ? 'תמיכה' : 'התנגדות'} במחיר ${price.toFixed(2)}`, 'success');
                    }
                  }}
                >
                  <i className="item-icon"><TargetPoint /></i>
                  <span>הוסף קו תמיכה/התנגדות</span>
                </div>
                <div 
                  className="context-menu-item"
                  onClick={() => {
                    if (contextMenu.candleIndex !== null) {
                      const candle = data[contextMenu.candleIndex];
                      
                      addImportantPoint(candle.time, candle.high + 150, 'red');
                      closeContextMenu();
                    }
                  }}
                >
                  <i className="item-icon"><PlusCircle /></i>
                  <span>הוסף נקודה חשובה</span>
                </div>
                <div className="context-menu-divider"></div>
                <div 
                  className="context-menu-item danger"
                  onClick={() => {
                    if (contextMenu.candleIndex !== null) {
                      removeCandle(contextMenu.candleIndex);
                      closeContextMenu();
                      
                      showToast('הסרת נר', 'הנר הוסר בהצלחה', 'info');
                    }
                  }}
                >
                  <i className="item-icon"><TrashCan /></i>
                  <span>מחק נר</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* שורת סטטוס */}
      <div className="status-bar">
        <div className="status-left">
          <div className="status-item">
            <i className="status-icon"><Chart /></i>
            <span>נרות: <span className="status-value">{data.length}</span></span>
          </div>
          <div className="status-item">
            <i className="status-icon"><DollarSign /></i>
            <span>
              מחיר נוכחי: 
              <span 
                className={`status-value ${data.length > 0 ? 
                  (data[data.length-1].close > data[data.length-1].open ? 'positive' : 'negative') : 
                  ''}`}
              >
                {data.length > 0 ? 
                  data[data.length-1].close.toLocaleString('he-IL', { minimumFractionDigits: 2 }) : 
                  '0.00'
                }
              </span>
            </span>
          </div>
          <div className="status-item">
            <i className="status-icon"><TrendingUp /></i>
            <span>טווח: <span className="status-value">
              {data.length > 0
                ? (Math.max(...data.map(c => c.high)) - Math.min(...data.map(c => c.low))).toLocaleString('he-IL', { minimumFractionDigits: 2 })
                : '0.00'
              }
            </span></span>
          </div>
        </div>
        <div className="status-right">
          <div className="status-item">
            <i className="status-icon"><Clock /></i>
            <span>עדכון אחרון: <span className="status-value">
              {data.length > 0 ? 
                new Date().toLocaleTimeString() : 
                'מעולם'
              }
            </span></span>
          </div>
          <div className="status-item">
            <i className="status-icon"><Calendar /></i>
            <span>תאריך: <span className="status-value">
              {new Date().toLocaleDateString()}
            </span></span>
          </div>
        </div>
      </div>

      {/* מודלים */}
      
      {/* מודל עריכת נר */}
      {isEditModalOpen && selectedCandleIndex !== null && (
        <div className="modal-overlay">
          <div className="modal edit-candle-modal">
            <div className="modal-header">
              <h3>עריכת נר</h3>
              <button className="close-button" onClick={() => setIsEditModalOpen(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="form-fields">
                <div className="form-field">
                  <label>פתיחה</label>
                  <input 
                    type="number" 
                    id="editOpen" 
                    step="0.01"
                    defaultValue={data[selectedCandleIndex].open}
                  />
                </div>
                <div className="form-field">
                  <label>גבוה</label>
                  <input 
                    type="number" 
                    id="editHigh" 
                    step="0.01"
                    defaultValue={data[selectedCandleIndex].high}
                  />
                </div>
                <div className="form-field">
                  <label>נמוך</label>
                  <input 
                    type="number" 
                    id="editLow" 
                    step="0.01"
                    defaultValue={data[selectedCandleIndex].low}
                  />
                </div>
                <div className="form-field">
                  <label>סגירה</label>
                  <input 
                    type="number" 
                    id="editClose" 
                    step="0.01"
                    defaultValue={data[selectedCandleIndex].close}
                  />
                </div>
                <div className="form-field">
                  <label>נפח</label>
                  <input 
                    type="number" 
                    id="editVolume" 
                    step="1"
                    defaultValue={data[selectedCandleIndex].volume || 500}
                  />
                </div>
              </div>
              
              <div className="slider-control">
                <label>סגירה יחסית לפתיחה</label>
                <div className="relative-close-control">
                  <input 
                    type="range" 
                    id="closeSlider" 
                    min="-10"
                    max="10"
                    step="0.1"
                    defaultValue="0"
                    onChange={(e) => {
                      const open = parseFloat(document.getElementById('editOpen').value);
                      const percent = parseFloat(e.target.value);
                      // חישוב שינוי מחיר באחוזים
                      const change = open * (percent / 100);
                      const newClose = open + change;
                      document.getElementById('editClose').value = newClose.toFixed(2);
                    }}
                  />
                  <div className="range-labels">
                    <span>-10%</span>
                    <span>0%</span>
                    <span>+10%</span>
                  </div>
                </div>
              </div>
              
              <div className="quick-actions">
                <button 
                  className="quick-action-btn"
                  onClick={() => {
                    // הפיכת הנר לקטן יותר (הקטנת גודל גוף ב-50%)
                    const open = parseFloat(document.getElementById('editOpen').value);
                    const close = parseFloat(document.getElementById('editClose').value);
                    
                    const currentSize = Math.abs(close - open);
                    const newSize = currentSize * 0.5;
                    
                    let newClose;
                    if (close > open) {
                      // נר עולה
                      newClose = open + newSize;
                    } else {
                      // נר יורד
                      newClose = open - newSize;
                    }
                    
                    document.getElementById('editClose').value = newClose.toFixed(2);
                  }}
                >
                  <i className="action-icon"><MinusCircle /></i>
                  <span>הקטן גוף</span>
                </button>
                <button 
                  className="quick-action-btn"
                  onClick={() => {
                    // הפיכת הנר לגדול יותר (הגדלת גודל גוף ב-50%)
                    const open = parseFloat(document.getElementById('editOpen').value);
                    const close = parseFloat(document.getElementById('editClose').value);
                    
                    const currentSize = Math.abs(close - open);
                    const newSize = currentSize * 1.5;
                    
                    let newClose;
                    if (close > open) {
                      // נר עולה
                      newClose = open + newSize;
                    } else {
                      // נר יורד
                      newClose = open - newSize;
                    }
                    
                    document.getElementById('editClose').value = newClose.toFixed(2);
                  }}
                >
                  <i className="action-icon"><PlusCircle /></i>
                  <span>הגדל גוף</span>
                </button>
                <button 
                  className="quick-action-btn"
                  onClick={() => {
                    // הוספת/הסרת פתילים
                    const open = parseFloat(document.getElementById('editOpen').value);
                    const close = parseFloat(document.getElementById('editClose').value);
                    const high = parseFloat(document.getElementById('editHigh').value);
                    const low = parseFloat(document.getElementById('editLow').value);
                    
                    // בדיקה אם לנר יש פתילים
                    const hasUpperWick = high > Math.max(open, close);
                    const hasLowerWick = low < Math.min(open, close);
                    
                    if (hasUpperWick || hasLowerWick) {
                      // הסרת פתילים
                      document.getElementById('editHigh').value = Math.max(open, close).toFixed(2);
                      document.getElementById('editLow').value = Math.min(open, close).toFixed(2);
                    } else {
                      // הוספת פתילים
                      const bodySize = Math.abs(close - open);
                      const wickSize = bodySize * 0.5;
                      
                      document.getElementById('editHigh').value = (Math.max(open, close) + wickSize).toFixed(2);
                      document.getElementById('editLow').value = (Math.min(open, close) - wickSize).toFixed(2);
                    }
                  }}
                >
                  <i className="action-icon"><RefreshCircle /></i>
                  <span>הוסף/הסר פתיל</span>
                </button>
                <button 
                  className="quick-action-btn"
                  onClick={() => {
                    // החלפת כיוון הנר
                    const open = parseFloat(document.getElementById('editOpen').value);
                    const close = parseFloat(document.getElementById('editClose').value);
                    
                    // החלפת פתיחה וסגירה
                    document.getElementById('editOpen').value = close.toFixed(2);
                    document.getElementById('editClose').value = open.toFixed(2);
                  }}
                >
                  <i className="action-icon"><RefreshCircle /></i>
                  <span>הפוך כיוון</span>
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-primary"
                onClick={() => {
                  // שמירת הנר המעודכן
                  const open = parseFloat(document.getElementById('editOpen').value);
                  const high = parseFloat(document.getElementById('editHigh').value);
                  const low = parseFloat(document.getElementById('editLow').value);
                  const close = parseFloat(document.getElementById('editClose').value);
                  const volume = parseInt(document.getElementById('editVolume').value || 500);
                  
                  // וידוא ערכים תקינים
                  if (high < Math.max(open, close)) {
                    showToast('שגיאת אימות', 'ערך הגבוה חייב להיות גדול או שווה לערכי הפתיחה והסגירה', 'error');
                    return;
                  }
                  
                  if (low > Math.min(open, close)) {
                    showToast('שגיאת אימות', 'ערך הנמוך חייב להיות קטן או שווה לערכי הפתיחה והסגירה', 'error');
                    return;
                  }
                  
                  // עדכון הנר
                  const updatedCandle = {
                    ...data[selectedCandleIndex],
                    open,
                    high,
                    low,
                    close,
                    volume
                  };
                  
                  saveEditedCandle(updatedCandle);
                }}
              >
                שמור שינויים
              </button>
              <button 
                className="btn-secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                ביטול
              </button>
              <button 
                className="btn-danger"
                onClick={() => {
                  removeCandle(selectedCandleIndex);
                  setIsEditModalOpen(false);
                  
                  showToast('הסרת נר', 'הנר הוסר בהצלחה', 'info');
                }}
              >
                <i className="btn-icon"><TrashCan /></i>
                מחק נר
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* מודל גרפים שמורים */}
      {isSavedChartsOpen && (
        <div className="modal-overlay">
          <div className="modal saved-charts-modal">
            <div className="modal-header">
              <h3>גרפים שמורים</h3>
              <button className="close-button" onClick={() => setIsSavedChartsOpen(false)}>×</button>
            </div>
            <div className="modal-content">
              {isLoadingData ? (
                <div className="loading-indicator">
                  <RefreshCircle className="rotating" />
                  <span>טוען גרפים שמורים...</span>
                </div>
              ) : savedCharts.length === 0 ? (
                <div className="empty-state">
                  <i className="empty-icon"><Chart /></i>
                  <p className="empty-message">אין גרפים שמורים</p>
                  {!user && <p className="empty-submessage">עליך להתחבר כדי לראות או לשמור גרפים</p>}
                </div>
              ) : (
                <div className="saved-charts-grid">
                  {savedCharts.map((chart) => (
                    <div key={chart.id} className="saved-chart-card">
                      <div className="chart-preview">
                        <div className="mini-chart">
                          {chart.candlestickData.slice(-15).map((candle, idx) => (
                            <div 
                              key={idx}
                              className={`mini-candle ${candle.close >= candle.open ? 'bullish' : 'bearish'}`}
                              style={{
                                height: `${Math.min(100, Math.max(10, Math.abs(candle.close - candle.open) / 50 * 100))}%`
                              }}
                            ></div>
                          ))}
                        </div>
                      </div>
                      <div className="chart-details">
                        <h4 className="chart-title">{chart.title || `גרף #${chart.id.slice(0, 4)}`}</h4>
                        <div className="chart-meta">
                          <span className="chart-date">{new Date(chart.savedAt.seconds * 1000).toLocaleDateString()}</span>
                          <span className="candle-count">{chart.candlestickData.length} נרות</span>
                        </div>
                        <div className="chart-tags">
                          {chart.tags && chart.tags.slice(0, 3).map((tag, idx) => (
                            <span key={idx} className="chart-tag">{tag}</span>
                          ))}
                          {chart.tags && chart.tags.length > 3 && <span className="more-tags">+{chart.tags.length - 3}</span>}
                        </div>
                      </div>
                      <div className="chart-actions">
                        <button 
                          className="load-chart-btn"
                          onClick={() => loadChartFromFirebase(chart.id)}
                        >
                          <DownloadCloud />
                          <span>טען</span>
                        </button>
                        <button 
                          className="delete-chart-btn"
                          onClick={() => {
                            showConfirmDialog(
                              'האם אתה בטוח שברצונך למחוק גרף זה?',
                              () => {
                                deleteChartFromFirebase(chart.id);
                                setIsConfirmModalOpen(false);
                              }
                            );
                          }}
                        >
                          <TrashCan />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button 
                className="btn-primary"
                onClick={() => {
                  if (user) {
                    fetchSavedCharts();
                  } else {
                    showToast('שגיאה', 'עליך להתחבר כדי לראות גרפים שמורים', 'error');
                  }
                }}
              >
                <i className="btn-icon"><RefreshCircle /></i>
                רענן
              </button>
              <button 
                className="btn-secondary"
                onClick={() => setIsSavedChartsOpen(false)}
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* מודל עזרה */}
      {isHelpModalOpen && (
        <div className="modal-overlay">
          <div className="modal help-modal">
            <div className="modal-header">
              <h3>עזרה - מערכת נרות יפניים</h3>
              <button className="close-button" onClick={() => setIsHelpModalOpen(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="help-section">
                <h4 className="help-title">יצירת גרף נרות</h4>
                <div className="help-steps">
                  <div className="help-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h5>הוספת נרות</h5>
                      <p>השתמש בלשונית "נרות" כדי להוסיף נרות עולים או יורדים בגדלים שונים, עם או בלי פתילים.</p>
                    </div>
                  </div>
                  <div className="help-step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h5>סימולציית מחיר</h5>
                      <p>השתמש בכפתור "הפעל" כדי ליצור נרות באופן אוטומטי בהתבסס על הגדרות השוק שבחרת.</p>
                    </div>
                  </div>
                  <div className="help-step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h5>נקודות חשובות</h5>
                      <p>סמן נקודות חשובות על הגרף לציון אזורי מפתח או אירועים חשובים.</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="help-section">
                <h4 className="help-title">ניווט וזום</h4>
                <div className="help-instructions">
                  <div className="instruction-item">
                    <div className="instruction-icon"><Search /></div>
                    <div className="instruction-text">
                      <strong>זום</strong>: השתמש בגלגלת העכבר להגדלה והקטנה.
                    </div>
                  </div>
                  <div className="instruction-item">
                    <div className="instruction-icon"><ArrowDown /></div>
                    <div className="instruction-text">
                      <strong>משיכה</strong>: לחץ וגרור את הגרף לצורך ניווט.
                    </div>
                  </div>
                  <div className="instruction-item">
                    <div className="instruction-icon"><Settings /></div>
                    <div className="instruction-text">
                      <strong>עריכת נר</strong>: לחיצה ימנית על נר תפתח תפריט פעולות.
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="help-section">
                <h4 className="help-title">שמירה וטעינה</h4>
                <div className="help-instructions">
                  <div className="instruction-item">
                    <div className="instruction-icon"><Save /></div>
                    <div className="instruction-text">
                      <strong>שמירה</strong>: לחץ על כפתור השמירה בסרגל העליון לשמירת הגרף ל-Firebase.
                    </div>
                  </div>
                  <div className="instruction-item">
                    <div className="instruction-icon"><DownloadCloud /></div>
                    <div className="instruction-text">
                      <strong>טעינה</strong>: לחץ על כפתור "טען גרף" ובחר מהגרפים השמורים.
                    </div>
                  </div>
                  <div className="instruction-item">
                    <div className="instruction-icon"><Image /></div>
                    <div className="instruction-text">
                      <strong>זיהוי מתמונה</strong>: העלה תמונת גרף לזיהוי אוטומטי של נרות.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-secondary"
                onClick={() => setIsHelpModalOpen(false)}
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* מודל אישור */}
      {isConfirmModalOpen && (
        <div className="modal-overlay">
          <div className="modal confirm-modal">
            <div className="modal-header">
              <h3>אישור פעולה</h3>
              <button className="close-button" onClick={() => setIsConfirmModalOpen(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="confirm-message">
                <i className="warning-icon"><AlertCircle /></i>
                <p>{confirmMessage}</p>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-danger"
                onClick={() => {
                  if (confirmAction) {
                    confirmAction();
                  }
                }}
              >
                אישור
              </button>
              <button 
                className="btn-secondary"
                onClick={() => setIsConfirmModalOpen(false)}
              >
                ביטול
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* מודל שיתוף */}
      {isShareModalOpen && (
        <div className="modal-overlay">
          <div className="modal share-modal">
            <div className="modal-header">
              <h3>שיתוף גרף</h3>
              <button className="close-button" onClick={() => setIsShareModalOpen(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="share-success">
                <i className="success-icon"><CheckCircle /></i>
                <p>הגרף נשמר ומוכן לשיתוף!</p>
              </div>
              
              <div className="share-link-container">
                <div className="share-link-label">קישור לשיתוף:</div>
                <div className="share-link-field">
                  <input 
                    type="text"
                    value={shareLink}
                    readOnly
                    className="share-link-input"
                  />
                  <button 
                    className="copy-link-btn"
                    onClick={() => {
                      navigator.clipboard.writeText(shareLink).then(
                        () => showToast('העתקה', 'הקישור הועתק ללוח', 'success'),
                        () => showToast('שגיאה', 'העתקה נכשלה', 'error')
                      );
                    }}
                  >
                    <i className="copy-icon"><Save /></i>
                    <span>העתק</span>
                  </button>
                </div>
              </div>
              
              <div className="share-options">
                <div className="share-option-label">אפשרויות שיתוף:</div>
                <div className="share-buttons">
                  <button className="share-option-btn">
                    <i className="share-option-icon email"></i>
                    <span>אימייל</span>
                  </button>
                  <button className="share-option-btn">
                    <i className="share-option-icon whatsapp"></i>
                    <span>וואטסאפ</span>
                  </button>
                  <button className="share-option-btn">
                    <i className="share-option-icon telegram"></i>
                    <span>טלגרם</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="btn-secondary"
                onClick={() => setIsShareModalOpen(false)}
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      )}

      {/* התראות */}
      <div className="toast-container">
        {toasts.map(toast => (
          <div 
            key={toast.id} 
            className={`toast ${toast.type}`}
          >
            <div className="toast-icon">
              {toast.type === 'success' && <CheckCircle />}
              {toast.type === 'error' && <AlertCircle />}
              {toast.type === 'warning' && <AlertCircle />}
              {toast.type === 'info' && <InfoCircle />}
            </div>
            <div className="toast-content">
              <h4 className="toast-title">{toast.title}</h4>
              <p className="toast-message">{toast.message}</p>
            </div>
            <button 
              className="toast-close"
              onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DarkCryptoPro;